import * as tslib_1 from "tslib";
/* tslint:disable:template-cyclomatic-complexity max-file-line-count */
import { HttpClient } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { LayerApi } from '../api/layer-api';
import { Callout } from '../classes/models/callout.model';
import { uuid } from '../classes/uuid';
import { environment } from '../environment';
import { ESRI } from '../esri-loader-util';
import { isCodedValueDomain, isFeatureLayer, isGraphicsLayer, isGroupLayer, isMapImageLayer, isPictureMarkerSymbol, isSymbolWithOutline, isSymbolWithSize, isSymbolWithWidth, LayerTypeId, LogLevel } from '../types';
import { LegendService } from './legend.service';
import { SplitThemeService } from './split-theme.service';
import { ThemeService } from './theme.service';
import { ToSqlStringService } from './to-sql-string.service';
import { TooltipService } from './tooltip.service';
import * as i0 from "@angular/core";
import * as i1 from "../api/layer-api";
import * as i2 from "./legend.service";
import * as i3 from "./split-theme.service";
import * as i4 from "./tooltip.service";
import * as i5 from "./theme.service";
import * as i6 from "./to-sql-string.service";
import * as i7 from "@angular/common/http";
//import { Color } from '@progress/kendo-drawing';
var QueryTask;
var Graphic;
var GroupLayer;
var LayerService = /** @class */ (function () {
    function LayerService(layerApi, legendService, splitThemeService, tooltipService, themeService, toSqlStringService, http, LoggingService) {
        this.layerApi = layerApi;
        this.legendService = legendService;
        this.splitThemeService = splitThemeService;
        this.tooltipService = tooltipService;
        this.themeService = themeService;
        this.toSqlStringService = toSqlStringService;
        this.http = http;
        this.LoggingService = LoggingService;
        this.AGGREGATE_LAYER_SUFFIXES = [' CENTER PT', ' BEGIN PT', ' END PT', ' PT', ' LN'];
        this.mapLayerType = LayerTypeId.Map;
        this.userLayerType = LayerTypeId.User;
        this.mapLayersSub = new Subject();
        this.polygonDefaultOpacity = 1;
        this.selectedLayer = null;
        this.layersRefreshed = new EventEmitter();
        this.checkIfHeatmapIsOnOrOff = function (layer) {
            return layer.mapcoreProps.heatmapMode === 'on' || (layer.mapcoreProps.heatmapMode === 'auto' && this.mapView.zoom < 16);
        };
        this.dataTypeMap = {
            OID: 'NUMBER',
            STRING: 'VARCHAR2',
            DOUBLE: 'FLOAT',
            INTEGER: 'NUMBER',
            'SMALL-INTEGER': 'NUMBER',
            DATE: 'DATE',
            'GLOBAL-ID': 'VARCHAR2',
            GUID: 'VARCHAR2'
            // additional types from DB: CLOB, CHAR, BLOB, TIMESTAMP(6), UNDEFINED
        };
    }
    Object.defineProperty(LayerService.prototype, "mapLayers", {
        get: function () {
            var e_1, _a, e_2, _b;
            var mapLayers = { dynamic: [], feature: [], graphics: [], mapImage: [] };
            if (this.mapRef && this.mapRef.layers) {
                try {
                    for (var _c = tslib_1.__values(this.mapRef.layers.toArray()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var layer = _d.value;
                        if (layer.type === 'group') {
                            try {
                                for (var _e = tslib_1.__values(layer.layers.toArray()), _f = _e.next(); !_f.done; _f = _e.next()) {
                                    var sub = _f.value;
                                    if (sub) {
                                        if (sub.type === 'map-image') {
                                            mapLayers.mapImage.push(sub);
                                        }
                                        else {
                                            mapLayers[sub.type].push(sub);
                                        }
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                        else {
                            if (layer.type === 'map-image') {
                                mapLayers.mapImage.push(layer);
                            }
                            else {
                                mapLayers[layer.type].push(layer);
                            }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            return mapLayers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerService.prototype, "mapView", {
        get: function () {
            return this._mapView;
        },
        set: function (mapView) {
            var _this = this;
            this._mapView = mapView;
            this.mapRef = mapView.map;
            this._mapView.watch('scale', this.onScaleChange.bind(this));
            var layers = mapView.map.allLayers;
            layers.on('change', function (event) { return _this.onLayerChange(event); });
            this.splitThemeService.mapView = this._mapView;
            this.themeService.mapView = this._mapView;
        },
        enumerable: true,
        configurable: true
    });
    LayerService.prototype.onScaleChange = function (newScale, _oldVal) {
        var e_3, _a;
        var callouts = Callout.fromLayers(this.mapLayers.graphics);
        try {
            for (var callouts_1 = tslib_1.__values(callouts), callouts_1_1 = callouts_1.next(); !callouts_1_1.done; callouts_1_1 = callouts_1.next()) {
                var callout = callouts_1_1.value;
                callout.updateGeometry(newScale);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (callouts_1_1 && !callouts_1_1.done && (_a = callouts_1.return)) _a.call(callouts_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    LayerService.prototype.onLayerChange = function (event) {
        var e_4, _a;
        var nonWebtileLayers = false;
        if (event && event.added && event.added.length > 0) {
            try {
                for (var _b = tslib_1.__values(event.added), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var layer = _c.value;
                    if (layer.type !== 'web-tile') {
                        nonWebtileLayers = true;
                        this.setUpLayerProperties(layer);
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        else if (event && (event.removed || event.moved)) {
            nonWebtileLayers = tslib_1.__spread(event.removed, event.moved).some(function (layer) { return layer.type !== 'web-tile'; });
        }
        if (nonWebtileLayers) {
            this.mapLayersSub.next(this.mapLayers);
        }
    };
    LayerService.prototype.setUpLayerProperties = function (layer) {
        var e_5, _a;
        switch (layer.type) {
            case 'feature':
                if (!layer.mapcoreProps) {
                    layer.mapcoreProps = {
                        name: layer.title
                    };
                }
                if (!layer.mapcoreProps.url && layer.url && layer.layerId) {
                    layer.mapcoreProps.url = layer.url + "/" + layer.layerId;
                }
                break;
            case 'map-image':
                if (layer.sublayers) {
                    try {
                        for (var _b = tslib_1.__values(layer.sublayers.toArray()), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var sublayer = _c.value;
                            if (!sublayer.mapcoreProps) {
                                sublayer.mapcoreProps = {
                                    id: sublayer.id,
                                    name: sublayer.name
                                };
                            }
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                }
                if (layer.mapcoreProps === undefined) {
                    layer.mapcoreProps = { symbols: '' };
                }
                layer.mapcoreProps.renderers = this.getRendererDefinitionsForLayer(layer);
                break;
            case 'dynamic':
                if (!layer.mapcoreProps) {
                    layer.mapcoreProps = {
                        id: layer.layerId,
                        name: layer.title,
                        url: layer.url
                    };
                }
                break;
            case 'graphics':
                if (layer.mapcoreProps === undefined) {
                    layer.mapcoreProps = {
                        id: layer.layerId,
                        hideInLegend: layer.hideInLegend
                    };
                }
                layer.mapcoreProps.name = layer.title ? layer.title : 'Graphic Layer';
                break;
            default:
                break;
        }
    };
    LayerService.prototype.convertToFeatureLayer = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_6, _a, _b, _c, sublayer, featureLayer, e_6_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        layer.convertingToFeatureLayer = true;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _b = tslib_1.__values(layer.sublayers.items), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 5];
                        sublayer = _c.value;
                        return [4 /*yield*/, sublayer.createFeatureLayer()];
                    case 3:
                        featureLayer = _d.sent();
                        featureLayer.mapcoreProps = layer.mapcoreProps;
                        featureLayer.visible = layer.visible;
                        featureLayer.opacity = layer.opacity;
                        return [2 /*return*/, featureLayer];
                    case 4:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_6_1 = _d.sent();
                        e_6 = { error: e_6_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_6) throw e_6.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.addLayer = function (layer, index) {
        this.mapRef.add(layer, index);
    };
    LayerService.prototype.removeLayer = function (layer) {
        this.mapRef.layers.remove(layer);
    };
    LayerService.prototype.removeLayerById = function (layerId) {
        var layers = this.mapRef.layers.toArray();
        var index = -1;
        layers.forEach(function (layer, idx) {
            if (layer.id === layerId) {
                return index = idx;
            }
        });
        if (index > -1) {
            this.mapRef.layers.removeAt(index);
        }
    };
    LayerService.prototype.getLayerIndex = function (currentLayer) {
        var layers = this.mapRef.layers.toArray();
        var index = -1;
        layers.forEach(function (layer, idx) {
            if (layer.id === currentLayer.id) {
                return index = idx;
            }
        });
        return index;
    };
    LayerService.prototype.getLayersFromApi = function (layerIds, props) {
        if (props === void 0) { props = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!props) {
                    props = "id isSystem name labelingInfoJSON graphicsJSON renderersJSON description queryJSON systemQueryJSON parentId finalFilter typeId lastEditedDate hoverColumnList url originalMinScale originalMaxScale routingDetailJSON\n                    featureEndpoints{url}\n                    sources{sourceType}\n                    tables{id geometryType name owner\n                        metaTable{id}\n                        spatialReference{wkt}\n                        tableEditableColumns{id name displayOrder inputType isEditable isInsertable validationType tableId}}\n                    columns {name alias databaseColumnOrder databaseDataLength databaseDataType columnIdentifierId, domainValueBasedFilter\n                    columnIdentifier{name}}\n                    categories(applicationId: " + environment.appId + "){name}\n                    permissions{id name action}";
                }
                return [2 /*return*/, this.layerApi.getLayers(layerIds, props)];
            });
        });
    };
    LayerService.prototype.getLayerChildTables = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.layerApi.getLayerChildTables(layerId)];
            });
        });
    };
    LayerService.prototype.getLayerChildTableRelationships = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.layerApi.getLayerChildRelationships(layerId, "id\n\t\t        childOwner\n  \t            parentLayerId\n                parentPrimaryKeyColumnName\n                layerChildRelationshipName\n                childTableName\n                childParentKeyColumnName")];
            });
        });
    };
    LayerService.prototype.getAllLayerChildTables = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.layerApi.getAllLayerChildTables()];
            });
        });
    };
    LayerService.prototype.getLayerChildTable = function (layerId, tableId, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.layerApi.getLayerChildTable(layerId, tableId, props)];
            });
        });
    };
    LayerService.prototype.getLayerChildTableWithData = function (layerId, tableId, fieldNames, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.layerApi.getLayerChildTableWithData(layerId, tableId, fieldNames, query)];
            });
        });
    };
    LayerService.prototype.getTableRMSKeysByName = function (tableName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tableRMSKeys;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getTableRMSKeysByName(tableName)];
                    case 1:
                        tableRMSKeys = _a.sent();
                        if (tableRMSKeys.length > 0) {
                            return [2 /*return*/, tableRMSKeys[0]];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.getTableRMSKeys = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tableRMSKeys;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getTableRMSKeys()];
                    case 1:
                        tableRMSKeys = _a.sent();
                        tableRMSKeys = tableRMSKeys.sort(function (a, b) {
                            var nameA = a.layerDisplayName.toUpperCase();
                            var nameB = b.layerDisplayName.toUpperCase();
                            if (nameA < nameB) {
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                            // names must be equal
                            return 0;
                        });
                        return [2 /*return*/, this.mergeIds(tableRMSKeys)];
                }
            });
        });
    };
    LayerService.prototype.mergeIds = function (list) {
        var e_7, _a;
        var out = [];
        var _loop_1 = function (entry) {
            var existingEntry = out.find(function (o) { return o.id === entry.id; });
            if (existingEntry) {
                existingEntry.tableIds = existingEntry.tableId.toString() + ", " + entry.tableId;
                existingEntry.tableName = existingEntry.tableName + ", " + entry.tableName;
            }
            else {
                out.push(entry);
            }
        };
        try {
            for (var list_1 = tslib_1.__values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                var entry = list_1_1.value;
                _loop_1(entry);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return out;
    };
    LayerService.prototype.getLayerTableChildren = function (parentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getLayerTableChildren(parentId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.getTable = function (tableId, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.layerApi.getTable(tableId, props)];
            });
        });
    };
    LayerService.prototype.getLayers = function (layerIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_8, _a, layersFromApi, resultLayers, layersFromApi_1, layersFromApi_1_1, layerFromApi, layerSettings, mapcoreProps, sourceType, _b, url, sublayers, properties, _c, MapImageLayer, mapImageLayer, e_8_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getLayersFromApi(layerIds)];
                    case 1:
                        layersFromApi = _d.sent();
                        resultLayers = [];
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 12, 13, 14]);
                        layersFromApi_1 = tslib_1.__values(layersFromApi), layersFromApi_1_1 = layersFromApi_1.next();
                        _d.label = 3;
                    case 3:
                        if (!!layersFromApi_1_1.done) return [3 /*break*/, 11];
                        layerFromApi = layersFromApi_1_1.value;
                        layerSettings = {};
                        return [4 /*yield*/, this.getUpdatedLayerSettings(layerSettings, layerFromApi)];
                    case 4:
                        layerSettings = _d.sent();
                        return [4 /*yield*/, this.getMapcoreProps(layerSettings, layerFromApi)];
                    case 5:
                        mapcoreProps = _d.sent();
                        sourceType = void 0;
                        if (layerFromApi.sources.length > 0) {
                            sourceType = layerFromApi.sources[0].sourceType;
                        }
                        _b = sourceType;
                        switch (_b) {
                            case 'DRAWING_DATA': return [3 /*break*/, 6];
                            case 'FEATURE_ENDPOINT': return [3 /*break*/, 6];
                            case 'LAYER_TABLE': return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 9];
                    case 6:
                        url = this.layerApi.Api.http2.url + 'arcgis/mapserver';
                        return [4 /*yield*/, this.getSublayers(layerSettings, mapcoreProps)];
                    case 7:
                        sublayers = _d.sent();
                        properties = {
                            url: url,
                            sublayers: sublayers,
                            visible: layerSettings.visible,
                            opacity: layerSettings.opacity
                        };
                        return [4 /*yield*/, Promise.all([ESRI.MapImageLayer])];
                    case 8:
                        _c = tslib_1.__read.apply(void 0, [_d.sent(), 1]), MapImageLayer = _c[0];
                        mapImageLayer = new MapImageLayer(properties);
                        mapImageLayer.mapcoreProps = mapcoreProps;
                        this.tooltipService.setupMapImageLayerPopupTemplate(mapImageLayer);
                        resultLayers.push(mapImageLayer);
                        return [3 /*break*/, 10];
                    case 9: return [3 /*break*/, 10];
                    case 10:
                        layersFromApi_1_1 = layersFromApi_1.next();
                        return [3 /*break*/, 3];
                    case 11: return [3 /*break*/, 14];
                    case 12:
                        e_8_1 = _d.sent();
                        e_8 = { error: e_8_1 };
                        return [3 /*break*/, 14];
                    case 13:
                        try {
                            if (layersFromApi_1_1 && !layersFromApi_1_1.done && (_a = layersFromApi_1.return)) _a.call(layersFromApi_1);
                        }
                        finally { if (e_8) throw e_8.error; }
                        return [7 /*endfinally*/];
                    case 14: return [2 /*return*/, resultLayers];
                }
            });
        });
    };
    LayerService.prototype.getTableColumns = function (tableId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = "displayName\n        columns {\n            name\n            dataType\n            dataLength\n        }\n        metaTable { id }";
                        return [4 /*yield*/, this.layerApi.getTable(tableId, props)];
                    case 1:
                        result = _a.sent();
                        if (result.length > 0) {
                            result[0].columns = result[0].columns.filter(function (x) { return x.dataType !== 'SDO_GEOMETRY'; });
                            result[0].columns = result[0].columns.filter(function (x) { return x.dataType !== 'BLOB'; });
                            result[0].columns = result[0].columns.filter(function (x) { return x.dataType !== 'CLOB'; });
                        }
                        return [2 /*return*/, result && result.length ? result[0] : null];
                }
            });
        });
    };
    LayerService.prototype.setFeatureLayerColumns = function (featureLayer) {
        var _this = this;
        if (featureLayer && featureLayer.loaded) {
            featureLayer.mapcoreProps.columns = featureLayer.fields.filter(function (field) { return field.type.toUpperCase() !== 'GEOMETRY'; }).map(function (field, i) {
                var matchedType = _this.dataTypeMap[field.type.toUpperCase()];
                if (!matchedType) {
                    console.warn("Missing type map '" + field.type + "' for feature layer");
                    matchedType = 'UNDEFINED';
                }
                var domainValues;
                if (field.domain) {
                    if (isCodedValueDomain(field.domain)) {
                        domainValues = field.domain.codedValues.map(function (val) { return ({
                            codeValue: val.code,
                            shortDescription: val.name,
                            longDescription: field.domain.name
                        }); });
                    }
                    else {
                        console.warn("Domain type '" + field.domain.type + "' not implemented", field.domain);
                    }
                }
                return {
                    alias: field.alias,
                    databaseColumnOrder: i,
                    databaseDataType: matchedType,
                    name: field.name.toLowerCase(),
                    databaseDataLength: field.length,
                    domainValues: domainValues
                };
            });
        }
    };
    LayerService.prototype.addExternalLayersToMap = function (layerSettings, mapcoreProps) {
        if (mapcoreProps === void 0) { mapcoreProps = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, FeatureLayer, featureLayer, queried, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (mapcoreProps === null) {
                            mapcoreProps = tslib_1.__assign({}, layerSettings);
                        }
                        mapcoreProps.isExternal = true;
                        if (!layerSettings.url && layerSettings.featureEndpoints) {
                            layerSettings.url = layerSettings.featureEndpoints[0].url;
                            mapcoreProps.url = layerSettings.url;
                        }
                        return [4 /*yield*/, Promise.all([ESRI.FeatureLayer])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 1]), FeatureLayer = _a[0];
                        featureLayer = new FeatureLayer({
                            url: layerSettings.url,
                            title: layerSettings.name,
                            visible: layerSettings.visible,
                            minScale: mapcoreProps.originalMinScale,
                            maxScale: mapcoreProps.originalMaxScale
                        });
                        if (!mapcoreProps.guid) {
                            mapcoreProps.guid = uuid.v1(null, 0, 0);
                        }
                        if (mapcoreProps.renderers) {
                            mapcoreProps.renderers = mapcoreProps.renderers.map(function (rend) { return _this.fixRenderer(rend); });
                            featureLayer.renderer = mapcoreProps.renderers[0];
                            if (mapcoreProps.renderers[0].symbol && mapcoreProps.renderers[0].symbol.type === 'picture-marker') {
                                this.fixPictureSymbols([featureLayer.renderer.symbol]);
                            }
                        }
                        featureLayer.mapcoreProps = mapcoreProps;
                        queried = false;
                        if (!(mapcoreProps.columns && mapcoreProps.query)) return [3 /*break*/, 3];
                        queried = true;
                        _b = featureLayer;
                        return [4 /*yield*/, this.toSqlStringService.getSql(mapcoreProps.query, mapcoreProps.columns)];
                    case 2:
                        _b.definitionExpression = _c.sent();
                        _c.label = 3;
                    case 3:
                        featureLayer.when(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        this.setFeatureLayerColumns(featureLayer);
                                        if (!(!queried && mapcoreProps.query)) return [3 /*break*/, 2];
                                        _a = featureLayer;
                                        return [4 /*yield*/, this.toSqlStringService.getSql(mapcoreProps.query, mapcoreProps.columns)];
                                    case 1:
                                        _a.definitionExpression = _b.sent();
                                        _b.label = 2;
                                    case 2:
                                        if (!layerSettings.zoomToLayer) return [3 /*break*/, 4];
                                        return [4 /*yield*/, this.zoomToLayer(featureLayer.id)];
                                    case 3:
                                        _b.sent();
                                        _b.label = 4;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); });
                        this.tooltipService.setupFeatureLayerPopupTemplate(featureLayer);
                        this.mapRef.add(featureLayer);
                        this.mapLayersSub.next(this.mapLayers);
                        return [2 /*return*/, featureLayer];
                }
            });
        });
    };
    LayerService.prototype.addFeatureSetLayerToMap = function (layers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_9, _b, layerConstructor, simpleRenderer, loadingPromises, lastColor, lastLayerPrefix, layers_1, layers_1_1, layer, layerPrefix, color, featureLayer;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.FeatureLayer, ESRI.SimpleRenderer])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 2]), layerConstructor = _a[0], simpleRenderer = _a[1];
                        loadingPromises = [];
                        try {
                            for (layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                                layer = layers_1_1.value;
                                layerPrefix = this.getLayerPrefix(layer.title);
                                color = layerPrefix !== lastLayerPrefix
                                    ? this.legendService.getNewColor(this.mapView.map)
                                    : lastColor;
                                layer.renderer = new simpleRenderer({
                                    symbol: this.themeService.getSymbolDefinitionFromGeometry(layer.source[0].geometry.type, color)
                                });
                                featureLayer = new layerConstructor(layer);
                                loadingPromises.push(featureLayer.when());
                                this.mapRef.layers.push(featureLayer);
                                lastColor = color;
                                lastLayerPrefix = layerPrefix;
                            }
                        }
                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
                        finally {
                            try {
                                if (layers_1_1 && !layers_1_1.done && (_b = layers_1.return)) _b.call(layers_1);
                            }
                            finally { if (e_9) throw e_9.error; }
                        }
                        return [2 /*return*/, Promise.all(loadingPromises)];
                }
            });
        });
    };
    LayerService.prototype.getLayerPrefix = function (title) {
        var e_10, _a;
        try {
            for (var _b = tslib_1.__values(this.AGGREGATE_LAYER_SUFFIXES), _c = _b.next(); !_c.done; _c = _b.next()) {
                var suffix = _c.value;
                if (title.endsWith(suffix)) {
                    return title.substring(0, title.indexOf(suffix));
                }
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_10) throw e_10.error; }
        }
        return title;
    };
    LayerService.prototype.addMapcoreLayersToMap = function (layerSettingsArray, query, zoomToLayer, generateNewLayer, paramConfig) {
        if (query === void 0) { query = null; }
        if (zoomToLayer === void 0) { zoomToLayer = false; }
        if (generateNewLayer === void 0) { generateNewLayer = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_11, _a, layerIds, layersFromApi, resultingEsriLayers, _loop_2, this_1, layerSettingsArray_1, layerSettingsArray_1_1, currentLayerSetting, e_11_1, _b, _c, _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        layerIds = layerSettingsArray.map(function (x) { return x.id; });
                        return [4 /*yield*/, this.getLayersFromApi(layerIds)];
                    case 1:
                        layersFromApi = _e.sent();
                        resultingEsriLayers = [];
                        _loop_2 = function (currentLayerSetting) {
                            var layerFromDatabase, sourceType, updatedLayerSettings, mapcoreProps, resultingEsriLayer, _a;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        layerFromDatabase = layersFromApi.filter(function (x) { return x.id === currentLayerSetting.id; })[0];
                                        if (!layerFromDatabase) return [3 /*break*/, 11];
                                        if (!currentLayerSetting.query) {
                                            currentLayerSetting.query = query;
                                        }
                                        if (currentLayerSetting.generateNewLayer === undefined) {
                                            currentLayerSetting.generateNewLayer = generateNewLayer;
                                        }
                                        if (currentLayerSetting.zoomToLayer === undefined) {
                                            currentLayerSetting.zoomToLayer = zoomToLayer;
                                        }
                                        sourceType = void 0;
                                        if (layerFromDatabase.sources && layerFromDatabase.sources.length > 0) {
                                            sourceType = layerFromDatabase.sources[0].sourceType;
                                        }
                                        return [4 /*yield*/, this_1.getUpdatedLayerSettings(currentLayerSetting, layerFromDatabase)];
                                    case 1:
                                        updatedLayerSettings = _b.sent();
                                        return [4 /*yield*/, this_1.getMapcoreProps(currentLayerSetting, layerFromDatabase)];
                                    case 2:
                                        mapcoreProps = _b.sent();
                                        resultingEsriLayer = void 0;
                                        _a = sourceType;
                                        switch (_a) {
                                            case 'FEATURE_ENDPOINT': return [3 /*break*/, 3];
                                            case 'DRAWING_DATA': return [3 /*break*/, 5];
                                            case 'LAYER_TABLE': return [3 /*break*/, 7];
                                        }
                                        return [3 /*break*/, 9];
                                    case 3: return [4 /*yield*/, this_1.addExternalLayersToMap(updatedLayerSettings, mapcoreProps)];
                                    case 4:
                                        resultingEsriLayer = _b.sent();
                                        return [3 /*break*/, 10];
                                    case 5: return [4 /*yield*/, this_1.addSavedGraphicsLayer(updatedLayerSettings, layerFromDatabase, mapcoreProps)];
                                    case 6:
                                        resultingEsriLayer = _b.sent();
                                        return [3 /*break*/, 10];
                                    case 7:
                                        if (paramConfig) {
                                            this_1.applyCyfyLayerFilterTransform(paramConfig, mapcoreProps);
                                            this_1.applyCurrentFYTransformation(mapcoreProps);
                                        }
                                        return [4 /*yield*/, this_1.addMapcoreLayer(updatedLayerSettings, mapcoreProps)];
                                    case 8:
                                        resultingEsriLayer = _b.sent();
                                        return [3 /*break*/, 10];
                                    case 9: return [3 /*break*/, 10];
                                    case 10:
                                        resultingEsriLayers.push(resultingEsriLayer);
                                        _b.label = 11;
                                    case 11: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _e.label = 2;
                    case 2:
                        _e.trys.push([2, 7, 8, 9]);
                        layerSettingsArray_1 = tslib_1.__values(layerSettingsArray), layerSettingsArray_1_1 = layerSettingsArray_1.next();
                        _e.label = 3;
                    case 3:
                        if (!!layerSettingsArray_1_1.done) return [3 /*break*/, 6];
                        currentLayerSetting = layerSettingsArray_1_1.value;
                        return [5 /*yield**/, _loop_2(currentLayerSetting)];
                    case 4:
                        _e.sent();
                        _e.label = 5;
                    case 5:
                        layerSettingsArray_1_1 = layerSettingsArray_1.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_11_1 = _e.sent();
                        e_11 = { error: e_11_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (layerSettingsArray_1_1 && !layerSettingsArray_1_1.done && (_a = layerSettingsArray_1.return)) _a.call(layerSettingsArray_1);
                        }
                        finally { if (e_11) throw e_11.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        _c = (_b = resultingEsriLayers.push).apply;
                        _d = [resultingEsriLayers];
                        return [4 /*yield*/, this.groupLayers(resultingEsriLayers)];
                    case 10:
                        _c.apply(_b, _d.concat([tslib_1.__spread.apply(void 0, [(_e.sent())])]));
                        return [2 /*return*/, resultingEsriLayers];
                }
            });
        });
    };
    LayerService.prototype.convertToImagelayer = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerSettings, index, mapcoreProps, mapImageLayer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layerSettings = null;
                        index = this.getLayerIndex(layer);
                        if (layer.mapcoreProps) {
                            mapcoreProps = layer.mapcoreProps;
                            layerSettings = { id: mapcoreProps.parentId, query: mapcoreProps.query, name: mapcoreProps.name, visible: layer.visible, opacity: layer.opacity };
                        }
                        return [4 /*yield*/, this.addMapcoreLayer(layerSettings, layer.mapcoreProps, index)];
                    case 1:
                        mapImageLayer = _a.sent();
                        mapImageLayer.mapcoreProps.url = undefined;
                        mapImageLayer.sublayers.forEach(function (sublayer) {
                            sublayer.renderer = layer.mapcoreProps.renderer;
                        });
                        return [2 /*return*/, mapImageLayer];
                }
            });
        });
    };
    LayerService.prototype.groupLayers = function (layers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groupedLayers, groupLayers, existingGroups, _loop_3, this_2, _a, _b, _i, group;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        groupedLayers = layers.filter(function (layer) { return layer.mapcoreProps.groupParent; }).reduce(function (acc, layer) {
                            var key = layer.mapcoreProps.groupParent.groupId ? "id:" + layer.mapcoreProps.groupParent.groupId : layer.mapcoreProps.groupParent.name;
                            if (acc[key]) {
                                acc[key].push(layer);
                            }
                            else {
                                acc[key] = [layer];
                            }
                            return acc;
                        }, {});
                        groupLayers = [];
                        if (!Object.keys(groupedLayers).length) return [3 /*break*/, 5];
                        return [4 /*yield*/, ESRI.GroupLayer];
                    case 1:
                        GroupLayer = _c.sent();
                        existingGroups = this.mapRef.layers.filter(function (layer) { return layer.type === 'group'; }).toArray();
                        _loop_3 = function (group) {
                            var e_12, _a, gl, groupData, groupLayer, groupId_1, splitTheme, gl_1, gl_1_1, layer;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!groupedLayers.hasOwnProperty(group)) return [3 /*break*/, 2];
                                        gl = groupedLayers[group];
                                        groupData = gl[0].mapcoreProps.groupParent;
                                        groupLayer = void 0;
                                        if (group.startsWith('id:')) {
                                            groupId_1 = group.replace('id:', '');
                                            groupLayer = existingGroups.find(function (egl) { return egl.id === groupId_1; });
                                        }
                                        if (!groupLayer) {
                                            splitTheme = groupData.splitThemeJSON && JSON.parse(groupData.splitThemeJSON);
                                            groupLayer = new GroupLayer({
                                                title: groupData.name,
                                                visible: true
                                            });
                                            groupLayer.mapcoreProps = { name: groupData.name, isGroupLayerExpanded: groupData.isOpen, splitTheme: splitTheme };
                                            this_2.mapRef.add(groupLayer);
                                            try {
                                                for (gl_1 = tslib_1.__values(gl), gl_1_1 = gl_1.next(); !gl_1_1.done; gl_1_1 = gl_1.next()) {
                                                    layer = gl_1_1.value;
                                                    layer.mapcoreProps.groupParent.groupId = groupLayer.id;
                                                    if (splitTheme) {
                                                        layer.mapcoreProps.splitTheme = splitTheme;
                                                    }
                                                }
                                            }
                                            catch (e_12_1) { e_12 = { error: e_12_1 }; }
                                            finally {
                                                try {
                                                    if (gl_1_1 && !gl_1_1.done && (_a = gl_1.return)) _a.call(gl_1);
                                                }
                                                finally { if (e_12) throw e_12.error; }
                                            }
                                        }
                                        groupLayer.addMany(gl);
                                        groupLayers.push(groupLayer);
                                        if (!groupLayer.mapcoreProps.splitTheme) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this_2.splitThemeService.rehydrateTheme(groupLayer)];
                                    case 1:
                                        _b.sent();
                                        _b.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_2 = this;
                        _a = [];
                        for (_b in groupedLayers)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        group = _a[_i];
                        return [5 /*yield**/, _loop_3(group)];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, groupLayers];
                }
            });
        });
    };
    LayerService.prototype.addMapcoreLayer = function (layerSettings, mapcoreProps, index) {
        if (mapcoreProps === void 0) { mapcoreProps = null; }
        if (index === void 0) { index = -1; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, holdRenderers, visualVariable_1, sublayers, properties, handle, mapImageLayer;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!mapcoreProps) {
                            mapcoreProps = layerSettings;
                        }
                        url = this.layerApi.Api.http2.url + 'arcgis/mapserver';
                        if (!mapcoreProps.renderers) return [3 /*break*/, 2];
                        mapcoreProps.renderers = mapcoreProps.renderers.map(function (rend) { return _this.fixRenderer(rend); });
                        if (!mapcoreProps.renderers.some(function (ren) { return ren.type === 'unique-value' || ren.type === 'class-breaks'; })) return [3 /*break*/, 2];
                        holdRenderers = mapcoreProps.renderers;
                        return [4 /*yield*/, ESRI.VisualVariable];
                    case 1:
                        visualVariable_1 = _a.sent();
                        if (mapcoreProps.renderers.length > 0 && mapcoreProps.renderers[0].visualVariables) {
                            holdRenderers[0].visualVariables = mapcoreProps.renderers[0].visualVariables.map(function (v) { return v = visualVariable_1.fromJSON(v); });
                        }
                        delete mapcoreProps.renderers;
                        delete layerSettings.renderers;
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.getSublayers(layerSettings, mapcoreProps)];
                    case 3:
                        sublayers = _a.sent();
                        if (holdRenderers && holdRenderers.length > 0 && holdRenderers[0].visualVariables) {
                            sublayers.forEach(function (sl) { return sl.renderer.visualVariables = holdRenderers[0].visualVariables; });
                        }
                        else if (mapcoreProps.renderers && mapcoreProps.renderers.visualVariables) {
                            sublayers.forEach(function (sl) { return sl.renderer.visualVariables = mapcoreProps.renderers.visualVariables; });
                        }
                        properties = {
                            url: url,
                            sublayers: sublayers,
                            visible: layerSettings.visible,
                            opacity: layerSettings.opacity,
                            minScale: mapcoreProps.originalMinScale,
                            maxScale: mapcoreProps.originalMaxScale
                        };
                        if (layerSettings.esriLayerId) {
                            properties.id = layerSettings.esriLayerId;
                        }
                        handle = this.mapView.map.allLayers.on('change', function (event) {
                            handle.remove();
                            var layer = event.added[0];
                            event.added.shift();
                            layer.on('layerview-destroy', function () { return _this.themeService.forgetTheme(layer); });
                            if (holdRenderers) {
                                setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var er_1;
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                layer.mapcoreProps.simpleRenderers = this.getRendererDefinitionsForLayer(layer);
                                                layer.mapcoreProps.renderers = layer.sublayers.map(function (sl) { return sl.renderer.toJSON(); }).toArray();
                                                if (holdRenderers[0].visualVariables) {
                                                    layer.mapcoreProps.renderers.forEach(function (rend) { return rend.visualVariables = holdRenderers[0].visualVariables; });
                                                    layer.mapcoreProps.simpleRenderers.forEach(function (rend) { return rend.visualVariables = holdRenderers[0].visualVariables; });
                                                }
                                                layer.sublayers.forEach(function (sl, i) { return sl.renderer = holdRenderers[i]; });
                                                this.themeService.saveTheme(layer, holdRenderers[0]);
                                                layer.mapcoreProps.isThemed = true;
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([1, 3, , 4]);
                                                return [4 /*yield*/, this.themeService.updateLayerTheme(layer)];
                                            case 2:
                                                _a.sent();
                                                return [3 /*break*/, 4];
                                            case 3:
                                                er_1 = _a.sent();
                                                if (er_1.message) {
                                                    this.LoggingService.Log('Layer Theme cannot be updated', er_1, LogLevel.Warn, false);
                                                }
                                                return [3 /*break*/, 4];
                                            case 4: return [2 /*return*/];
                                        }
                                    });
                                }); }, 10);
                            }
                        });
                        return [4 /*yield*/, this.addEsriMapImagelayer(properties, mapcoreProps, index)];
                    case 4:
                        mapImageLayer = _a.sent();
                        if (!layerSettings.zoomToLayer) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.zoomToLayer(mapImageLayer.id)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/, mapImageLayer];
                }
            });
        });
    };
    LayerService.prototype.setIsPetl = function (mapcoreProps) {
        if (mapcoreProps &&
            ((mapcoreProps.tableNames && mapcoreProps.tableNames.some(function (table) { return table.toUpperCase().includes('RMS_PETL'); }))
                || (mapcoreProps.tables && mapcoreProps.tables.some(function (table) { return table.name && table.name.toUpperCase().includes('RMS_PETL'); })))) {
            mapcoreProps.isPETL = true;
        }
    };
    LayerService.prototype.addEsriMapImagelayer = function (mapImageProperties, mapcoreProps, index) {
        if (mapcoreProps === void 0) { mapcoreProps = null; }
        if (index === void 0) { index = -1; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, MapImageLayer, mapImageLayer;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.MapImageLayer])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), MapImageLayer = _a[0];
                        mapImageLayer = new MapImageLayer(mapImageProperties);
                        if (index > -1) {
                            this.mapRef.add(mapImageLayer, index);
                        }
                        else {
                            this.mapRef.add(mapImageLayer);
                        }
                        if (mapcoreProps) {
                            mapImageLayer.mapcoreProps = mapcoreProps;
                        }
                        this.tooltipService.setupMapImageLayerPopupTemplate(mapImageLayer);
                        return [2 /*return*/, mapImageLayer];
                }
            });
        });
    };
    LayerService.prototype.zoomToLayer = function (layerId, zoomThreshold) {
        if (zoomThreshold === void 0) { zoomThreshold = 14; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_13, _a, layer, layerExtent, extents, layerId_1, layerId_1_1, id, layer, layerExtent, e_13_1, totalExtent;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof layerId === 'string')) return [3 /*break*/, 3];
                        layer = this.getExistingEsriLayerById(layerId);
                        return [4 /*yield*/, this.getLayerExtent(layer)];
                    case 1:
                        layerExtent = _b.sent();
                        return [4 /*yield*/, this.validExtent(layerExtent)];
                    case 2:
                        if (_b.sent()) {
                            this.zoomToTarget(layerExtent, undefined, zoomThreshold);
                        }
                        return [3 /*break*/, 13];
                    case 3:
                        extents = [];
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 10, 11, 12]);
                        layerId_1 = tslib_1.__values(layerId), layerId_1_1 = layerId_1.next();
                        _b.label = 5;
                    case 5:
                        if (!!layerId_1_1.done) return [3 /*break*/, 9];
                        id = layerId_1_1.value;
                        layer = this.getExistingEsriLayerById(id);
                        return [4 /*yield*/, this.getLayerExtent(layer)];
                    case 6:
                        layerExtent = _b.sent();
                        return [4 /*yield*/, this.validExtent(layerExtent)];
                    case 7:
                        if (_b.sent()) {
                            extents.push(layerExtent);
                        }
                        _b.label = 8;
                    case 8:
                        layerId_1_1 = layerId_1.next();
                        return [3 /*break*/, 5];
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        e_13_1 = _b.sent();
                        e_13 = { error: e_13_1 };
                        return [3 /*break*/, 12];
                    case 11:
                        try {
                            if (layerId_1_1 && !layerId_1_1.done && (_a = layerId_1.return)) _a.call(layerId_1);
                        }
                        finally { if (e_13) throw e_13.error; }
                        return [7 /*endfinally*/];
                    case 12:
                        if (extents.length) {
                            totalExtent = extents.reduce(function (a, b) { return a.union(b); });
                            this.zoomToTarget(totalExtent, undefined, zoomThreshold);
                        }
                        _b.label = 13;
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.getLayerExtent = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Extent;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.QueryTask];
                    case 1:
                        QueryTask = _b.sent();
                        return [4 /*yield*/, Promise.all([ESRI.Extent])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), Extent = _a[0];
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                try {
                                    layer.when(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                        var e_14, _a, extents, extent, queryPromises_1, responses, extent, responses_1, responses_1_1, res, e_14_1, query, response;
                                        return tslib_1.__generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    if (!isGraphicsLayer(layer)) return [3 /*break*/, 1];
                                                    extents = layer.graphics.toArray().map(function (graphic) {
                                                        var ext;
                                                        if (graphic.geometry.type === 'point') {
                                                            var p = graphic.geometry;
                                                            ext = new Extent({ xmax: p.x, xmin: p.x, ymax: p.y, ymin: p.y, spatialReference: p.spatialReference });
                                                        }
                                                        else {
                                                            ext = graphic.geometry.extent.clone();
                                                        }
                                                        return ext;
                                                    });
                                                    extent = extents.reduce(function (a, b) { return a.union(b); });
                                                    resolve(extent);
                                                    return [3 /*break*/, 16];
                                                case 1:
                                                    if (!isMapImageLayer(layer)) return [3 /*break*/, 13];
                                                    queryPromises_1 = [];
                                                    layer.sublayers.forEach(function (sublayer) {
                                                        var clonedSublayer = sublayer.clone();
                                                        var task = new QueryTask({ url: clonedSublayer.url });
                                                        queryPromises_1.push(task.executeForExtent(clonedSublayer.createQuery()));
                                                    });
                                                    return [4 /*yield*/, Promise.all(queryPromises_1)];
                                                case 2:
                                                    responses = _b.sent();
                                                    extent = responses.pop().extent;
                                                    _b.label = 3;
                                                case 3:
                                                    _b.trys.push([3, 10, 11, 12]);
                                                    responses_1 = tslib_1.__values(responses), responses_1_1 = responses_1.next();
                                                    _b.label = 4;
                                                case 4:
                                                    if (!!responses_1_1.done) return [3 /*break*/, 9];
                                                    res = responses_1_1.value;
                                                    return [4 /*yield*/, this.validExtent(extent)];
                                                case 5:
                                                    if (!_b.sent()) return [3 /*break*/, 7];
                                                    return [4 /*yield*/, this.validExtent(res.extent)];
                                                case 6:
                                                    if (_b.sent()) {
                                                        extent.union(res.extent);
                                                    }
                                                    return [3 /*break*/, 8];
                                                case 7:
                                                    extent = res.extent;
                                                    _b.label = 8;
                                                case 8:
                                                    responses_1_1 = responses_1.next();
                                                    return [3 /*break*/, 4];
                                                case 9: return [3 /*break*/, 12];
                                                case 10:
                                                    e_14_1 = _b.sent();
                                                    e_14 = { error: e_14_1 };
                                                    return [3 /*break*/, 12];
                                                case 11:
                                                    try {
                                                        if (responses_1_1 && !responses_1_1.done && (_a = responses_1.return)) _a.call(responses_1);
                                                    }
                                                    finally { if (e_14) throw e_14.error; }
                                                    return [7 /*endfinally*/];
                                                case 12:
                                                    resolve(extent);
                                                    return [3 /*break*/, 16];
                                                case 13:
                                                    if (!isFeatureLayer(layer)) return [3 /*break*/, 15];
                                                    query = layer.createQuery();
                                                    query.outSpatialReference = this.mapView.spatialReference.clone();
                                                    return [4 /*yield*/, layer.queryExtent(query)];
                                                case 14:
                                                    response = _b.sent();
                                                    resolve(response.extent);
                                                    return [3 /*break*/, 16];
                                                case 15:
                                                    resolve(layer.fullExtent);
                                                    _b.label = 16;
                                                case 16: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                }
                                catch (er) {
                                    reject(er);
                                }
                            })];
                }
            });
        });
    };
    LayerService.prototype.getLayerCopyRight = function (basemapConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var serviceUrl, result, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!basemapConfig.copyrightText && basemapConfig.tileUrl && (basemapConfig.tileUrl.toLowerCase().indexOf('mapserver') > -1 || basemapConfig.tileUrl.toLowerCase().indexOf('imageserver') > -1))) return [3 /*break*/, 4];
                        serviceUrl = basemapConfig.tileUrl.substr(0, basemapConfig.tileUrl.toLowerCase().indexOf('tile')) + "?f=pjson";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.http.get(serviceUrl).toPromise()];
                    case 2:
                        result = _b.sent();
                        basemapConfig.copyrightText = result.copyrightText || null;
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.validExtent = function (extent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Extent;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.Extent])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), Extent = _a[0];
                        if (extent instanceof Extent) {
                            return [2 /*return*/, Boolean(extent.xmax || extent.xmin || extent.ymax || extent.ymin)];
                        }
                        else {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.copyEsriLayer = function (esriLayer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapcoreProps, layerSettings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!esriLayer.mapcoreProps) return [3 /*break*/, 2];
                        mapcoreProps = esriLayer.mapcoreProps;
                        layerSettings = { id: mapcoreProps.parentId, query: mapcoreProps.query, name: mapcoreProps.name, parentQuery: esriLayer.mapcoreProps.parentQuery };
                        return [4 /*yield*/, this.addMapcoreLayersToMap([layerSettings])];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, []];
                }
            });
        });
    };
    LayerService.prototype.copyLayerInternal = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, foundLayer, url, layerConstructor, subLayers, dynamicMapServiceLayer;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        foundLayer = this.getEsriLayerByUniqueId(layerId);
                        url = this.layerApi.Api.http2.url + 'arcgis/MapServer';
                        return [4 /*yield*/, Promise.all([ESRI.MapImageLayer, ESRI.SpatialReference])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), layerConstructor = _a[0];
                        return [4 /*yield*/, this.getSublayers(foundLayer.mapcoreProps)];
                    case 2:
                        subLayers = _b.sent();
                        dynamicMapServiceLayer = new layerConstructor({
                            url: url,
                            sublayers: subLayers,
                            visible: foundLayer.visible ? foundLayer.visible : false
                        });
                        dynamicMapServiceLayer.mapcoreProps = {};
                        Object.assign(dynamicMapServiceLayer.mapcoreProps, foundLayer.mapcoreProps);
                        return [2 /*return*/, dynamicMapServiceLayer];
                }
            });
        });
    };
    LayerService.prototype.createClippedRMSGeom = function (clipRanges) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.layerApi.createClippedRMSGeom(clipRanges)];
            });
        });
    };
    LayerService.prototype.addMapcoreLayerIdsToMap = function (layerIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerReferences;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layerReferences = layerIds.map(function (x) { return ({ id: x }); });
                        return [4 /*yield*/, this.addMapcoreLayersToMap(layerReferences)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.getSublayers = function (layerSettings, mapcoreProps) {
        if (mapcoreProps === void 0) { mapcoreProps = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_15, _b, SpatialReference, Sublayer, sublayers, spatialReference, sublayerDefinitions, sublayerDefinitions_1, sublayerDefinitions_1_1, sublayerDefinition, newSub;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mapcoreProps) {
                            mapcoreProps = layerSettings;
                        }
                        return [4 /*yield*/, Promise.all([ESRI.SpatialReference, ESRI.Sublayer])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 2]), SpatialReference = _a[0], Sublayer = _a[1];
                        sublayers = [];
                        spatialReference = new SpatialReference({ wkid: 102100 });
                        if (mapcoreProps.tables && mapcoreProps.tables[0].spatialReference && mapcoreProps.tables[0].spatialReference.wkt) {
                            spatialReference = new SpatialReference({ wkt: mapcoreProps.tables[0].spatialReference.wkt });
                        }
                        return [4 /*yield*/, this.getSublayerDefinitionsFromMapcoreProps(layerSettings, mapcoreProps)];
                    case 2:
                        sublayerDefinitions = _c.sent();
                        try {
                            for (sublayerDefinitions_1 = tslib_1.__values(sublayerDefinitions), sublayerDefinitions_1_1 = sublayerDefinitions_1.next(); !sublayerDefinitions_1_1.done; sublayerDefinitions_1_1 = sublayerDefinitions_1.next()) {
                                sublayerDefinition = sublayerDefinitions_1_1.value;
                                sublayerDefinition.source.dataSource.spatialReference = spatialReference;
                                newSub = new Sublayer(sublayerDefinition);
                                newSub.mapcoreProps = mapcoreProps;
                                sublayers.push(newSub);
                            }
                        }
                        catch (e_15_1) { e_15 = { error: e_15_1 }; }
                        finally {
                            try {
                                if (sublayerDefinitions_1_1 && !sublayerDefinitions_1_1.done && (_b = sublayerDefinitions_1.return)) _b.call(sublayerDefinitions_1);
                            }
                            finally { if (e_15) throw e_15.error; }
                        }
                        return [2 /*return*/, sublayers];
                }
            });
        });
    };
    LayerService.prototype.getUpdatedLayerSettings = function (layerSettings, layerFromDatabase) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var defaultOpacity;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layerSettings.id = layerFromDatabase.id;
                        layerSettings.isSystem = layerFromDatabase.isSystem;
                        layerSettings.name = layerSettings.name ? layerSettings.name : layerFromDatabase.name;
                        layerSettings.description = layerFromDatabase.description ? layerFromDatabase.description : 'No description available';
                        layerSettings.columns = layerSettings.columns ? layerSettings.columns : layerFromDatabase.columns;
                        layerSettings.hoverColumnList = layerSettings.hoverColumnList ? layerSettings.hoverColumnList : layerFromDatabase.hoverColumnList;
                        layerSettings.sources = layerFromDatabase.sources;
                        layerSettings.geometryTypes = layerFromDatabase.tables ? layerFromDatabase.tables.map(function (x) { return x.geometryType; }) : layerFromDatabase.geometryTypes;
                        this.formatGeometryTypes(layerSettings);
                        layerSettings.parentId = layerFromDatabase.parentId ? layerFromDatabase.parentId : null;
                        layerSettings.typeId = layerFromDatabase.typeId;
                        layerSettings.visible = layerSettings.visible === undefined ? true : layerSettings.visible;
                        layerSettings.originalMinScale = layerSettings.originalMinScale ? layerSettings.originalMinScale : layerFromDatabase.originalMinScale;
                        layerSettings.originalMaxScale = layerSettings.originalMaxScale ? layerSettings.originalMaxScale : layerFromDatabase.originalMaxScale;
                        defaultOpacity = 1;
                        if (layerFromDatabase.isSystem && layerSettings.opacity === undefined && layerSettings.geometryTypes[0] === 'polygon') {
                            layerSettings.opacity = this.polygonDefaultOpacity;
                        }
                        else if (layerSettings.opacity === undefined) {
                            layerSettings.opacity = defaultOpacity;
                        }
                        if (layerFromDatabase.featureEndpoints && layerFromDatabase.featureEndpoints.length) {
                            layerSettings.url = layerFromDatabase.featureEndpoints[0].url;
                        }
                        if (layerFromDatabase.labelingInfoJSON) {
                            layerSettings.labelingInfo = JSON.parse(layerFromDatabase.labelingInfoJSON);
                        }
                        if (layerFromDatabase.routingDetailJSON) {
                            layerSettings.routingDetail = JSON.parse(layerFromDatabase.routingDetailJSON);
                        }
                        return [4 /*yield*/, this.layerSettingsRenderersSetup(layerSettings, layerFromDatabase)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, layerSettings];
                }
            });
        });
    };
    LayerService.prototype.layerSettingsRenderersSetup = function (layerSettings, layerFromDatabase) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var i, renderer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!layerSettings.renderers) return [3 /*break*/, 2];
                        if (layerFromDatabase.renderers && !Array.isArray(layerFromDatabase.renderers)) {
                            layerSettings.renderers = JSON.parse(layerFromDatabase.renderers);
                        }
                        else if (layerFromDatabase.renderersJSON) {
                            layerSettings.renderers = JSON.parse(layerFromDatabase.renderersJSON);
                        }
                        else if (layerSettings.renderersJSON) {
                            layerSettings.renderers = JSON.parse(layerSettings.renderersJSON);
                        }
                        return [4 /*yield*/, this.setupRenderers(layerSettings.renderers)];
                    case 1:
                        _a.sent();
                        if (layerSettings.renderers && layerSettings.renderers.length) {
                            for (i = layerSettings.renderers.length - 1; i >= 0; i--) {
                                renderer = layerSettings.renderers[i];
                                if (renderer.type && renderer.type === 'opacity') {
                                    layerSettings.opacity = renderer.value;
                                    layerSettings.renderers.splice(i, 1);
                                }
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.setupRenderers = function (renderers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var SimpleRenderer, i, renderer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!renderers) return [3 /*break*/, 2];
                        return [4 /*yield*/, ESRI.SimpleRenderer];
                    case 1:
                        SimpleRenderer = _a.sent();
                        for (i = renderers.length - 1; i >= 0; i--) {
                            renderer = renderers[i];
                            if (renderer.symbol && renderer.symbol.type.startsWith('esri')) {
                                // ESRI's toJSON doesn't save a color to a line symbol even though fromJSON needs it
                                if (!renderer.symbol.color && renderer.symbol.outline && renderer.symbol.outline.color) {
                                    renderer.symbol.color = renderer.symbol.outline.color;
                                }
                                renderers[i] = SimpleRenderer.fromJSON(renderer);
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.getMapcoreProps = function (layerSettings, layerFromDatabase) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapcoreProps;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mapcoreProps = this.setMapcorePropsObject(layerSettings, layerFromDatabase);
                        this.setIsPetl(mapcoreProps);
                        //validating query properly in all scenarios
                        this.generateMapcorePropsQuery(mapcoreProps, layerSettings, layerFromDatabase);
                        this.formatGeometryTypes(mapcoreProps);
                        if (layerFromDatabase.tables && layerFromDatabase.tables[0] && layerFromDatabase.tables[0].metaTable) {
                            mapcoreProps.metaTableId = layerFromDatabase.tables[0].metaTable.id;
                        }
                        // If system layer, there won't be a parentId so map/user layer that will be created will have parentId as the sytem layer's Id
                        // Otherwise, get Id from database to use for possible layer update (does not apply to system layer since it cannot be updated)
                        if (layerFromDatabase.isSystem) {
                            mapcoreProps.id = null;
                            mapcoreProps.parentId = layerFromDatabase.id;
                        }
                        else {
                            mapcoreProps.idFromSavedLayer = layerFromDatabase.id;
                            if (layerSettings.generateNewLayer) {
                                mapcoreProps.idFromSavedMap = layerFromDatabase.id;
                                mapcoreProps.id = null;
                            }
                        }
                        mapcoreProps.parentQuery = layerSettings.parentQuery ? layerSettings.parentQuery : JSON.parse(layerFromDatabase.systemQueryJSON);
                        if (layerFromDatabase.featureEndpoints && layerFromDatabase.featureEndpoints.length) {
                            mapcoreProps.url = layerFromDatabase.featureEndpoints[0].url;
                        }
                        mapcoreProps.renderers = layerSettings.renderers;
                        if (layerSettings.exportJoinFilterParams) {
                            mapcoreProps.exportJoinFilterParams = layerSettings.exportJoinFilterParams;
                        }
                        return [4 /*yield*/, this.setColumns(layerSettings, mapcoreProps, layerFromDatabase)];
                    case 1:
                        _a.sent();
                        if (layerSettings && layerSettings.geometryString) {
                            mapcoreProps.geometryString = layerSettings.geometryString;
                        }
                        this.setSpatialParams(mapcoreProps);
                        if (layerSettings && layerSettings.splitThemeLabel) {
                            mapcoreProps.splitThemeLabel = layerSettings.splitThemeLabel;
                        }
                        return [2 /*return*/, mapcoreProps];
                }
            });
        });
    };
    LayerService.prototype.generateMapcorePropsQuery = function (mapcoreProps, layerSettings, layerFromDatabase) {
        mapcoreProps.query = {
            childTableRecord: null,
            childTableQuery: {},
            joinRecord: null,
            joinTableQuery: {},
            operator: '',
            field: '',
            value: '',
            subqueries: []
        };
        var queryAssigned = false;
        if (this.isProperQuery(layerSettings.query)) {
            mapcoreProps.query = layerSettings.query;
            queryAssigned = true;
        }
        if (layerSettings.query && layerSettings.query.childTableRecord) {
            mapcoreProps.query.childTableRecord = layerSettings.query.childTableRecord;
            if (this.isProperQuery(layerSettings.query.childTableQuery)) {
                mapcoreProps.query.childTableQuery = layerSettings.query.childTableQuery;
            }
            queryAssigned = true;
        }
        if (layerSettings.query && layerSettings.query.joinRecord) {
            mapcoreProps.query.joinRecord = layerSettings.query.joinRecord;
            if (this.isProperQuery(layerSettings.query.joinTableQuery)) {
                mapcoreProps.query.joinTableQuery = layerSettings.query.joinTableQuery;
            }
            queryAssigned = true;
        }
        if (!queryAssigned && layerFromDatabase.queryJSON && (layerFromDatabase.typeId === this.userLayerType || layerFromDatabase.typeId === this.mapLayerType)) {
            mapcoreProps.query = JSON.parse(layerFromDatabase.queryJSON);
            if (mapcoreProps.query && mapcoreProps.query.parentQuery) {
                delete mapcoreProps.query.parentQuery;
            }
            queryAssigned = true;
        }
        if (!queryAssigned || !mapcoreProps.query) {
            mapcoreProps.query = {};
        }
    };
    LayerService.prototype.setColumns = function (layerSettings, mapcoreProps, layerFromDatabase) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_16, _a, petlQueries, columns, _loop_4, _b, _c, existingColumn;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (layerSettings.joinColumns) {
                            mapcoreProps.joinColumns = layerSettings.joinColumns;
                        }
                        if (layerSettings.childColumns) {
                            mapcoreProps.childColumns = layerSettings.childColumns;
                        }
                        if (!mapcoreProps.isPETL) return [3 /*break*/, 3];
                        petlQueries = this.toSqlStringService.getClauses(mapcoreProps.query, { field: 'project_no', operator: '=' });
                        if (!(petlQueries && petlQueries.length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.layerApi.getPetlProjectColumnAliases(parseInt(petlQueries[0].value, 10))];
                    case 1:
                        columns = _d.sent();
                        if (columns && columns.length) {
                            _loop_4 = function (existingColumn) {
                                var matchingPetlCol = columns.find(function (col) { return col.columnName.toLowerCase().trim() === existingColumn.name.toLowerCase().trim(); });
                                if (matchingPetlCol) {
                                    existingColumn.alias = matchingPetlCol.aliasName;
                                }
                            };
                            try {
                                for (_b = tslib_1.__values(mapcoreProps.columns), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    existingColumn = _c.value;
                                    _loop_4(existingColumn);
                                }
                            }
                            catch (e_16_1) { e_16 = { error: e_16_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_16) throw e_16.error; }
                            }
                        }
                        _d.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        if (layerFromDatabase.tables && layerFromDatabase.tables.some(function (table) { return !!table.tableEditableColumns; })) {
                            mapcoreProps.tableEditableColumns = layerFromDatabase.tables.map(function (table) { return table.tableEditableColumns; }).flat();
                            mapcoreProps.tableEditableColumns.forEach(function (tec) {
                                if (typeof tec.inputType === 'string') {
                                    tec.inputType = JSON.parse(tec.inputType);
                                }
                            });
                        }
                        _d.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.isProperQuery = function (query) {
        var _this = this;
        if (query && query.subqueries) {
            var result_1 = true;
            query.subqueries.forEach(function (subQuery) {
                result_1 = result_1 && _this.isProperQuery(subQuery);
            });
            return result_1;
        }
        else {
            return query && (query.field && query.operator && (query.value !== null || query.operator.toLowerCase().includes('null')));
        }
    };
    LayerService.prototype.setMapcorePropsObject = function (layerSettings, layerFromDatabase) {
        return {
            columns: layerSettings.columns,
            hoverColumnList: layerSettings.hoverColumnList,
            id: layerFromDatabase.id,
            hoverEnabled: layerSettings.hoverEnabled,
            identifyEnabled: layerSettings.identifyEnabled,
            identifyNonVisibleEnabled: layerSettings.identifyNonVisibleEnabled,
            isSystem: layerFromDatabase.isSystem,
            isAOI: layerSettings.isAOI,
            name: layerSettings.name || layerFromDatabase.name,
            description: layerFromDatabase.description,
            groupParent: layerSettings.groupParent,
            sources: layerFromDatabase.sources,
            spatialQueryParams: layerSettings.spatialQueryParams,
            geometryTypes: layerFromDatabase.tables ? layerFromDatabase.tables.map(function (x) { return x.geometryType; }) : layerFromDatabase.geometryTypes,
            parentId: layerFromDatabase.parentId ? layerFromDatabase.parentId : null,
            tableNames: layerFromDatabase.tables ? layerFromDatabase.tables.map(function (t) { return t.name; }) : layerFromDatabase.tableNames,
            typeId: layerFromDatabase.typeId,
            visible: layerSettings.visible,
            tables: layerFromDatabase.tables,
            category: layerFromDatabase.categories ? layerFromDatabase.categories.map(function (c) { return c.name; }).join(', ') : null,
            labelingInfo: layerSettings.labelingInfo,
            lastEditedDate: layerFromDatabase.lastEditedDate,
            hideInLegend: layerSettings.hideInLegend !== undefined ? layerSettings.hideInLegend : undefined,
            permissions: layerFromDatabase.permissions,
            originalMinScale: layerFromDatabase.originalMinScale,
            originalMaxScale: layerFromDatabase.originalMaxScale,
            routingDetail: layerSettings.routingDetail
        };
    };
    LayerService.prototype.setSpatialParams = function (mapcoreProps) {
        if (!mapcoreProps.spatialQueryParams && mapcoreProps.query && mapcoreProps.query.spatialQueryParams) {
            mapcoreProps.spatialQueryParams = mapcoreProps.query.spatialQueryParams;
            delete mapcoreProps.query.spatialQueryParams;
        }
    };
    LayerService.prototype.formatGeometryTypes = function (mapcoreProps) {
        var p = 'point';
        mapcoreProps.geometryTypes = mapcoreProps.geometryTypes.map(function (x) { return x.toLowerCase().trim(); });
        if (mapcoreProps.geometryTypes.length > 1 && mapcoreProps.geometryTypes.includes(p)) {
            mapcoreProps.geometryTypes.sort(function (a, b) { return a === p ? -1 : b === p ? 1 : 0; });
        }
    };
    LayerService.prototype.getSublayerDefinitionsFromMapcoreProps = function (layerSettings, mapcoreProps) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_17, _a, sublayerDefinitions, _b, _c, geometryType, geometryTypeModified, workspaceId, keepColor, renderer, finalQuery, sublayerDef;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        sublayerDefinitions = [];
                        return [4 /*yield*/, this.setupRenderers(layerSettings.renderers)];
                    case 1:
                        _d.sent();
                        try {
                            for (_b = tslib_1.__values(mapcoreProps.geometryTypes), _c = _b.next(); !_c.done; _c = _b.next()) {
                                geometryType = _c.value;
                                geometryTypeModified = geometryType.replace('line', 'polyline');
                                workspaceId = mapcoreProps.parentId;
                                keepColor = mapcoreProps.geometryTypes.indexOf(geometryType) !== 0 && mapcoreProps.geometryTypes.length > 1;
                                renderer = this.themeService.getRenderDefinitionForGeometryType(geometryType, keepColor, layerSettings.renderers);
                                finalQuery = tslib_1.__assign({}, mapcoreProps.query);
                                if (mapcoreProps.parentQuery) {
                                    finalQuery = this.toSqlStringService.addFilter(tslib_1.__assign({}, mapcoreProps.query), mapcoreProps.parentQuery);
                                }
                                if (!finalQuery) {
                                    finalQuery = {};
                                }
                                sublayerDef = {
                                    title: mapcoreProps.name,
                                    renderer: renderer,
                                    visible: true,
                                    source: {
                                        type: 'data-layer',
                                        dataSource: {
                                            type: 'query-table',
                                            geometryType: geometryTypeModified,
                                            workspaceId: workspaceId.toString(),
                                            query: JSON.stringify(finalQuery),
                                            oidFields: this.getObjectIdColumnName(mapcoreProps)
                                        },
                                        fields: null
                                    },
                                    labelingInfo: mapcoreProps.labelingInfo
                                };
                                sublayerDefinitions.push(sublayerDef);
                            }
                        }
                        catch (e_17_1) { e_17 = { error: e_17_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_17) throw e_17.error; }
                        }
                        if (!layerSettings.renderers) {
                            this.setSublayerColors(sublayerDefinitions);
                        }
                        return [2 /*return*/, sublayerDefinitions];
                }
            });
        });
    };
    LayerService.prototype.setSublayerColors = function (sublayerDefinitions) {
        var e_18, _a;
        var color;
        try {
            for (var _b = tslib_1.__values(sublayerDefinitions.filter(function (sld) {
                return sld.renderer.type !== 'unique-value'
                    && sld.renderer.type !== 'uniqueValue'
                    && sld.renderer.type !== 'class-breaks'
                    && sld.renderer.type !== 'classBreaks';
            })), _c = _b.next(); !_c.done; _c = _b.next()) {
                var definition = _c.value;
                if (!color) {
                    color = definition.renderer.symbol.color;
                }
                else {
                    definition.renderer.symbol.color = color;
                }
            }
        }
        catch (e_18_1) { e_18 = { error: e_18_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_18) throw e_18.error; }
        }
    };
    LayerService.prototype.updateLayerFilter = function (esriLayer, query, updateLayerTheme) {
        if (updateLayerTheme === void 0) { updateLayerTheme = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_19, _a, newSublayers, _b, _c, sublayer, finalQuery, clonedSublayer, er_2;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (esriLayer.mapcoreProps) {
                            esriLayer.mapcoreProps.query = query;
                        }
                        if (!(esriLayer.type === 'map-image')) return [3 /*break*/, 4];
                        newSublayers = [];
                        try {
                            for (_b = tslib_1.__values(esriLayer.sublayers.toArray()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                sublayer = _c.value;
                                if (sublayer.source.type === 'data-layer' && sublayer.source.dataSource.type === 'query-table') {
                                    finalQuery = this.toSqlStringService.addFilter(tslib_1.__assign({}, query), esriLayer.mapcoreProps.parentQuery);
                                    sublayer.source.dataSource.query = JSON.stringify(finalQuery);
                                }
                                clonedSublayer = sublayer.clone();
                                clonedSublayer.mapcoreProps = tslib_1.__assign({}, sublayer.mapcoreProps);
                                if (clonedSublayer.mapcoreProps.renderers && clonedSublayer.mapcoreProps.renderers.length && clonedSublayer.mapcoreProps.renderers[0].visualVariables) {
                                    clonedSublayer.renderer.visualVariables = clonedSublayer.mapcoreProps.renderers[0].visualVariables;
                                }
                                newSublayers.push(clonedSublayer);
                            }
                        }
                        catch (e_19_1) { e_19 = { error: e_19_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_19) throw e_19.error; }
                        }
                        esriLayer.sublayers.removeAll();
                        esriLayer.sublayers.addMany(newSublayers);
                        this.tooltipService.setupMapImageLayerPopupTemplate(esriLayer);
                        if (!(esriLayer.mapcoreProps.isThemed && updateLayerTheme)) return [3 /*break*/, 4];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.themeService.updateLayerTheme(esriLayer, false)];
                    case 2:
                        _d.sent();
                        this.mapLayersSub.next();
                        return [3 /*break*/, 4];
                    case 3:
                        er_2 = _d.sent();
                        if (er_2.message) {
                            this.LoggingService.Log('Layer Theme cannot be updated', er_2, LogLevel.Warn, false);
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        esriLayer.refresh();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.updateJoinLayerColumns = function (esriLayer, joinColumns, childColumns) {
        if (esriLayer.mapcoreProps) {
            esriLayer.mapcoreProps.joinColumns = joinColumns;
            esriLayer.mapcoreProps.childColumns = childColumns;
        }
        esriLayer.refresh();
    };
    LayerService.prototype.getExistingEsriLayerById = function (id) {
        var retVal = null;
        var layers = this.mapRef.layers.toArray();
        layers.forEach(function (layer) {
            var e_20, _a;
            if (layer.id === id && !retVal) {
                retVal = layer;
            }
            else if (isGroupLayer(layer)) {
                try {
                    for (var _b = tslib_1.__values(layer.layers), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var sublayer = _c.value;
                        if (sublayer.id === id && !retVal) {
                            retVal = sublayer;
                        }
                    }
                }
                catch (e_20_1) { e_20 = { error: e_20_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_20) throw e_20.error; }
                }
            }
        });
        return retVal;
    };
    LayerService.prototype.getStringifiedRenderersForLayer = function (layer) {
        var rendererDefinitions = this.getRendererDefinitionsForLayer(layer);
        return JSON.stringify(rendererDefinitions);
    };
    LayerService.prototype.getRendererDefinitionsForLayer = function (layer) {
        var e_21, _a;
        var rendererDefinitions = [];
        if (layer.sublayers && layer.sublayers.length) {
            try {
                for (var _b = tslib_1.__values(layer.sublayers.toArray()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var sublayer = _c.value;
                    if (sublayer.renderer) {
                        rendererDefinitions.push(this.fixRenderer(sublayer.renderer));
                    }
                }
            }
            catch (e_21_1) { e_21 = { error: e_21_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_21) throw e_21.error; }
            }
        }
        return rendererDefinitions;
    };
    LayerService.prototype.fixRenderer = function (renderer) {
        var _this = this;
        var e_22, _a;
        var rend;
        if (renderer.toJSON) {
            rend = renderer.toJSON();
        }
        else {
            rend = renderer;
        }
        rend.type = rend.type.replace('uniqueValue', 'unique-value').replace('classBreaks', 'class-breaks');
        if (rend.field1) {
            rend.field = rend.field1;
            delete rend.field1;
        }
        if (rend.symbol) {
            this.legendService.convertSymbolJSONToSymbolDefinition(rend.symbol);
        }
        if (rend.defaultSymbol) {
            this.legendService.convertSymbolJSONToSymbolDefinition(rend.defaultSymbol);
        }
        if (rend.uniqueValueInfos) {
            try {
                for (var _b = tslib_1.__values(rend.uniqueValueInfos), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var uniqueValueInfo = _c.value;
                    if (uniqueValueInfo.symbol) {
                        this.legendService.convertSymbolJSONToSymbolDefinition(uniqueValueInfo.symbol);
                    }
                }
            }
            catch (e_22_1) { e_22 = { error: e_22_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_22) throw e_22.error; }
            }
        }
        if (rend.classBreakInfos) {
            var minValue_1 = rend.minValue || 0;
            delete rend.minValue;
            rend.classBreakInfos.forEach(function (classBreakInfo, i, arr) {
                if (classBreakInfo.symbol) {
                    if (!classBreakInfo.minValue) {
                        classBreakInfo.minValue = i === 0 ? minValue_1 : arr[i - 1].maxValue;
                    }
                    if (classBreakInfo.classMaxValue) {
                        classBreakInfo.maxValue = classBreakInfo.classMaxValue;
                    }
                    _this.legendService.convertSymbolJSONToSymbolDefinition(classBreakInfo.symbol);
                }
            });
        }
        // fixes some issues with external layers
        if (rend.authoringInfo && rend.authoringInfo.colorRamp) {
            if (renderer.authoringInfo.colorRamp.colorRamps) {
                rend.authoringInfo.colorRamp.colorRamps.forEach(function (colorRamp) {
                    colorRamp = _this.fixAuthoringInfoColorRamp(colorRamp);
                });
            }
            else {
                rend.authoringInfo.colorRamp = this.fixAuthoringInfoColorRamp(rend.authoringInfo.colorRamp);
            }
        }
        return rend;
    };
    // fixes color ramp that is not set up correctly, mainly found in some external layers
    LayerService.prototype.fixAuthoringInfoColorRamp = function (colorRamp) {
        switch (colorRamp.algorithm) {
            case 'esriCIELabAlgorithm':
                colorRamp.algorithm = 'cie-lab';
                break;
            case 'esriHSVAlgorithm':
                colorRamp.algorithm = 'hsv';
                break;
            case 'esriLabLChAlgorithm':
                colorRamp.algorithm = 'lab-lch';
                break;
            default:
                break;
        }
        if (colorRamp.type) {
            delete colorRamp.type;
        }
        return colorRamp;
    };
    LayerService.prototype.getStringifiedGraphicsForLayer = function (layer) {
        var e_23, _a;
        var graphicDefinitions = [];
        if (layer.graphics) {
            try {
                for (var _b = tslib_1.__values(layer.graphics), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var graphic = _c.value;
                    var graphicDefinition = graphic.toJSON();
                    graphicDefinition.geometry.type = graphic.geometry.type;
                    this.legendService.convertSymbolJSONToSymbolDefinition(graphicDefinition.symbol);
                    graphicDefinitions.push(graphicDefinition);
                }
            }
            catch (e_23_1) { e_23 = { error: e_23_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_23) throw e_23.error; }
            }
        }
        return JSON.stringify(graphicDefinitions);
    };
    LayerService.prototype.getStringifiedFeaturesForLayer = function (layer) {
        var e_24, _a;
        var featureDefinitions = [];
        if (layer.source && layer.source) {
            try {
                for (var _b = tslib_1.__values(layer.source), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var feature = _c.value;
                    var featureDefinition = feature.toJSON();
                    featureDefinition.geometry.type = feature.geometry.type;
                    if (featureDefinition.symbol !== null) {
                        featureDefinition.symbol = featureDefinition.symbol;
                    }
                    else {
                        var layerSymbolRef = layer.renderer.symbol;
                        featureDefinition.symbol = {
                            color: [layerSymbolRef.color.r, layerSymbolRef.color.g, layerSymbolRef.color.b, layerSymbolRef.color.a],
                            style: layerSymbolRef.style,
                            type: layerSymbolRef.type
                        };
                        if (isSymbolWithWidth(layerSymbolRef)) {
                            featureDefinition.symbol.width = layerSymbolRef.width;
                        }
                        if (isSymbolWithSize(layerSymbolRef)) {
                            featureDefinition.symbol.size = layerSymbolRef.size;
                        }
                        if (isSymbolWithOutline(layerSymbolRef)) {
                            featureDefinition.symbol.outline = {
                                color: [layerSymbolRef.outline.color.r, layerSymbolRef.outline.color.g, layerSymbolRef.outline.color.b, layerSymbolRef.outline.color.a],
                                style: layerSymbolRef.outline.style,
                                type: layerSymbolRef.outline.type,
                                width: layerSymbolRef.outline.width
                            };
                        }
                    }
                    this.legendService.convertSymbolJSONToSymbolDefinition(featureDefinition.symbol);
                    featureDefinitions.push(featureDefinition);
                }
            }
            catch (e_24_1) { e_24 = { error: e_24_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_24) throw e_24.error; }
            }
        }
        return JSON.stringify(featureDefinitions);
    };
    LayerService.prototype.getEsriLayerByUniqueId = function (uniqueId) {
        return this.mapRef.findLayerById(uniqueId);
    };
    LayerService.prototype.getLayerRecordCount = function (layerId, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getLayerRecordCount(layerId, query ? query : null)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.getDistinctValuesNoQuery = function (layerId, columnName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getDistinctValues(layerId, columnName)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.getDistinctValues = function (layerId, columnName, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getDistinctValues(layerId, columnName, query)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.getExternalServiceProperties = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getExternalLayerJson(layer)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.getExternalLayerJson = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var esriRequest, response, e_25, retVal, esriGeometryType, renderer, symbols_1, k;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Request];
                    case 1:
                        esriRequest = (_a.sent());
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, esriRequest(layer.url + "?f=json", {
                                responseType: 'json'
                            })];
                    case 3:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_25 = _a.sent();
                        this.LoggingService.Log("Unable to load the requested layer from " + new URL(e_25.details.url).host, e_25, LogLevel.Error, false);
                        throw new Error(e_25);
                    case 5:
                        retVal = tslib_1.__assign({}, layer);
                        if (response && response.data) {
                            if (!retVal.name) {
                                if (response.data.documentInfo && response.data.documentInfo.Title) {
                                    retVal.name = response.data.documentInfo.Title;
                                }
                            }
                            esriGeometryType = response.data.geometryType;
                            if (response.data.drawingInfo && response.data.drawingInfo.renderer) {
                                renderer = response.data.drawingInfo.renderer;
                                symbols_1 = [];
                                if (renderer.symbol) {
                                    symbols_1.push(renderer.symbol);
                                }
                                else if (renderer.uniqueValueInfos) {
                                    renderer.uniqueValueInfos.forEach(function (value) {
                                        value.symbol.label = value.label;
                                        symbols_1.push(value.symbol);
                                    });
                                }
                                if (!retVal.legend) {
                                    this.setLegendSymbolsForExternalLayer(retVal, symbols_1, esriGeometryType);
                                }
                            }
                            for (k in response.data) {
                                if (k !== 'id') {
                                    retVal[k] = response.data[k]; //Don't take the id from the external service.
                                }
                            }
                        }
                        return [2 /*return*/, retVal];
                }
            });
        });
    };
    LayerService.prototype.setLegendSymbolsForExternalLayer = function (layer, symbols, symbolGeometryType) {
        var _this = this;
        var geometryType = layer.geometryType || this.getTerseGeometryType(symbolGeometryType);
        if (geometryType) {
            geometryType = geometryType.toLowerCase();
        }
        layer.legend = [];
        layer.legendData = [];
        symbols.forEach(function (s) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var symbol, symbolColor, borderColor, esriBackgroundColor, esriBorderColor;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!s) return [3 /*break*/, 3];
                        symbol = tslib_1.__assign({}, s);
                        symbolColor = symbol.fillColor || symbol.color;
                        borderColor = void 0;
                        if ((geometryType === 'polygon') && symbol.outline && symbol.outline.color) {
                            borderColor = symbol.outline.color;
                        }
                        layer.legend.push(symbol);
                        if (!(symbolColor && geometryType)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.legendService.getEsriColor(symbolColor)];
                    case 1:
                        esriBackgroundColor = _a.sent();
                        return [4 /*yield*/, this.legendService.getEsriColor(borderColor)];
                    case 2:
                        esriBorderColor = _a.sent();
                        if (typeof esriBackgroundColor.toHex === 'function') {
                            symbol.backgroundColor = esriBackgroundColor.toHex();
                            if (parseFloat(esriBackgroundColor.a) === 0) {
                                symbol.backgroundColor = 'none'; // Setting backgroundcolor none when Layer Opacity is zero.
                            }
                        }
                        if (borderColor) {
                            if (typeof esriBorderColor.toHex === 'function') {
                                symbol.borderColor = esriBorderColor.toHex();
                            }
                        }
                        symbol.type = geometryType;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    LayerService.prototype.getExternalLayerSymbolData = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (layer.legend) {
                            // We already have legend property present, don't get a new one. This can happen if the
                            // layer symbology was already loaded through the UI, Map record, Layer record or injected
                            // through an API call from a host.
                            return [2 /*return*/, layer];
                        }
                        if (layer.legendData && layer.legendData.legend) {
                            // We do have a legendData.legend property, copy to legend.
                            layer.legend = layer.legendData.legend;
                            return [2 /*return*/, layer];
                        }
                        return [4 /*yield*/, this.getExternalLegendJson(layer)];
                    case 1:
                        result = _a.sent();
                        if (!!result.legend) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getExternalLayerJson(layer)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    };
    LayerService.prototype.getTerseGeometryType = function (esriGeometryType) {
        if (esriGeometryType) {
            var geometryType = esriGeometryType.toLowerCase().replace(/esri|multi|geometry/g, '').toUpperCase();
            return geometryType.replace('POLYLINE', 'LINE');
        }
        return null;
    };
    LayerService.prototype.getExternalLegendJson = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var esriRequest, legendUrl, layerId, response, layerResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (layer.url.toLowerCase().indexOf('/featureserver/') > 0) {
                            layer.layerType = layer.type; //Usually the legend request below sets the layerType, so since that won't get called, we set it here instead.
                            return [2 /*return*/, layer];
                        }
                        return [4 /*yield*/, ESRI.Request];
                    case 1:
                        esriRequest = (_a.sent());
                        if (/^https?:\/\/.*\/[0-9]{1,}$/.test(layer.url)) {
                            legendUrl = layer.url.substring(0, layer.url.lastIndexOf('/')) + "/legend";
                            // tslint:disable-next-line:restrict-plus-operands
                            layerId = parseInt(layer.url.substring(layer.url.lastIndexOf('/') + 1), 0);
                        }
                        else {
                            legendUrl = layer.url + "/legend";
                        }
                        return [4 /*yield*/, esriRequest(legendUrl + "?f=json", {
                                responseType: 'json'
                            })];
                    case 2:
                        response = _a.sent();
                        if (response && response.data && response.data.layers) {
                            layerResult = response.data.layers.find(function (r) {
                                return r.layerId === layerId || r.id === layerId;
                            });
                            layer = tslib_1.__assign({}, layer, layerResult);
                            if (layerResult && layerResult.legend) {
                                layer.displayName = ((layer.displayName) ? layer.displayName : layerResult.layerName);
                            }
                        }
                        return [2 /*return*/, layer];
                }
            });
        });
    };
    LayerService.prototype.addSavedGraphicsLayer = function (layerSettings, layer, mapcoreProps) {
        if (mapcoreProps === void 0) { mapcoreProps = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var graphics, graphicsLayer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!layer.graphicsJSON) return [3 /*break*/, 2];
                        graphics = JSON.parse(layer.graphicsJSON);
                        return [4 /*yield*/, this.addGraphicsLayer({
                                graphics: graphics, title: layer.name, visible: layerSettings.visible, opacity: layerSettings.opacity, minScale: mapcoreProps.originalMinScale, maxScale: mapcoreProps.originalMaxScale
                            })];
                    case 1:
                        graphicsLayer = _a.sent();
                        if (mapcoreProps) {
                            graphicsLayer.mapcoreProps = mapcoreProps;
                        }
                        return [2 /*return*/, graphicsLayer];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.addGraphicsLayer = function (properties, mapcoreProps) {
        if (mapcoreProps === void 0) { mapcoreProps = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_26, _a, GraphicsLayer, hasPictureMarkerSymbol, _b, _c, g, layer;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, ESRI.GraphicsLayer];
                    case 1:
                        GraphicsLayer = _d.sent();
                        hasPictureMarkerSymbol = false;
                        if (properties.graphics) {
                            try {
                                for (_b = tslib_1.__values(properties.graphics), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    g = _c.value;
                                    if (g.symbol.type === 'esriPMS') {
                                        g.symbol.type = 'picture-marker';
                                        hasPictureMarkerSymbol = true;
                                    }
                                }
                            }
                            catch (e_26_1) { e_26 = { error: e_26_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_26) throw e_26.error; }
                            }
                        }
                        layer = new GraphicsLayer(properties);
                        if (mapcoreProps) {
                            layer.mapcoreProps = mapcoreProps;
                        }
                        if (hasPictureMarkerSymbol) {
                            this.fixPictureSymbols(layer.graphics.map(function (g) { return g.symbol; }).toArray());
                        }
                        this.tooltipService.setupGraphicsLayerPopupTemplate(layer);
                        this.mapRef.add(layer);
                        return [2 /*return*/, layer];
                }
            });
        });
    };
    LayerService.prototype.zoomToGraphic = function (graphic) {
        this.zoomToTarget(graphic.geometry);
    };
    // Zooms to the extent of the target.
    // If the total extent size of the target's geometries is above the set threshold, it zooms to that extent.
    // otherwise, a default zoom is applied to prevent zooming in too close.
    LayerService.prototype.zoomToTarget = function (target, heightOrWidthThreshold, zoomThreshold) {
        if (heightOrWidthThreshold === void 0) { heightOrWidthThreshold = 2000; }
        if (zoomThreshold === void 0) { zoomThreshold = 14; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_27, _a, geometries, totalExtent, geometries_1, geometries_1_1, geometry, maxWidthOrHeight, goToTarget;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        geometries = [];
                        if (target.length) {
                            geometries = target;
                        }
                        else {
                            geometries.push(target);
                        }
                        geometries = geometries.filter(function (x) { return x; });
                        try {
                            for (geometries_1 = tslib_1.__values(geometries), geometries_1_1 = geometries_1.next(); !geometries_1_1.done; geometries_1_1 = geometries_1.next()) {
                                geometry = geometries_1_1.value;
                                if (!totalExtent && geometry.extent) {
                                    totalExtent = geometry.extent.clone();
                                }
                                else if (geometry.extent) {
                                    totalExtent.union(geometry.extent);
                                }
                            }
                        }
                        catch (e_27_1) { e_27 = { error: e_27_1 }; }
                        finally {
                            try {
                                if (geometries_1_1 && !geometries_1_1.done && (_a = geometries_1.return)) _a.call(geometries_1);
                            }
                            finally { if (e_27) throw e_27.error; }
                        }
                        maxWidthOrHeight = 0;
                        if (totalExtent) {
                            maxWidthOrHeight = Math.max(maxWidthOrHeight, totalExtent.height, totalExtent.width);
                        }
                        goToTarget = (maxWidthOrHeight > heightOrWidthThreshold) ? geometries : { target: geometries, zoom: zoomThreshold };
                        return [4 /*yield*/, this.mapView.goTo(goToTarget, { animate: true })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerService.prototype.moveLayerToTheTop = function (layer) {
        this.mapRef.reorder(layer, this.mapRef.allLayers.length - 1);
    };
    LayerService.prototype.moveLayerToTheBottom = function (layer) {
        this.mapRef.reorder(layer, 0);
    };
    LayerService.prototype.moveLayerAbove = function (layer, lowerLayer) {
        var lowerLayerIndex = this.mapRef.layers.indexOf(lowerLayer);
        if (lowerLayerIndex > -1) {
            this.mapRef.reorder(layer, lowerLayerIndex + 1);
        }
        else {
            this.moveLayerToTheTop(layer);
        }
    };
    LayerService.prototype.moveLayerBelow = function (layer, higherLayer) {
        var higherLayerIndex = this.mapRef.layers.indexOf(higherLayer);
        if (higherLayerIndex > -1) {
            this.mapRef.reorder(layer, higherLayerIndex);
        }
        else {
            this.moveLayerToTheBottom(layer);
        }
    };
    LayerService.prototype.convertGeometry = function (geometry) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Polyline, Polygon, geometryJSON;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.loadModules('esri/geometry/Polyline', 'esri/geometry/Polygon')];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), Polyline = _a[0], Polygon = _a[1];
                        geometryJSON = geometry.flat().map(function (a) {
                            if (a === null) {
                                return;
                            }
                            if (a.includes('POINT')) {
                                a = a.replace('POINT (', '');
                                a = a.replace(')', '');
                                var coords = a.split(' ');
                                return {
                                    type: 'point', x: parseFloat(coords[0]), y: parseFloat(coords[1]), spatialReference: { wkid: 102100 }
                                };
                            }
                            else if (a.includes('LINESTRING')) {
                                a = a.replace(/MULTI|LINESTRING|\(|\)/gi, '');
                                var b = a.split(',');
                                var coordsArray = b.map(function (c) {
                                    var coords = c.trim().split(' ');
                                    return [parseFloat(coords[0]), parseFloat(coords[1])];
                                });
                                return new Polyline({
                                    paths: [coordsArray], spatialReference: { wkid: 102100 }
                                });
                            }
                            else if (a.includes('MULTIPOLYGON')) {
                                a = a.replace('MULTIPOLYGON ', '');
                                var arr = a.split(')), (');
                                var polygons = arr.map(function (item) {
                                    var b = item.split('(');
                                    var coordsArray = b.map(function (c) {
                                        if (!c) {
                                            return;
                                        }
                                        var d = c.split(',');
                                        return d.map(function (e) {
                                            e = e.trim();
                                            if (!e) {
                                                return;
                                            }
                                            e = e.replace(/\(/gi, '');
                                            e = e.replace(/\)/gi, '');
                                            var coords = e.trim().split(' ');
                                            return [parseFloat(coords[0]), parseFloat(coords[1])];
                                        }).filter(function (v) { return !!v; });
                                    });
                                    coordsArray = coordsArray.filter(function (v) { return !!v; });
                                    var polygon = new Polygon({
                                        rings: coordsArray, spatialReference: { wkid: 102100 }
                                    });
                                    if (!polygon.isClockwise(polygon.rings)) {
                                        for (var i = 0; i < polygon.rings.length; i++) {
                                            polygon.rings[i] = polygon.rings[i].reverse();
                                        }
                                    }
                                    return polygon;
                                });
                                return polygons;
                            }
                            else if (a.includes('POLYGON')) {
                                a = a.replace('POLYGON (', '');
                                a = a.replace(')', '');
                                var b = a.split('(');
                                var coordsArray = b.map(function (c) {
                                    if (!c) {
                                        return;
                                    }
                                    var d = c.split(',');
                                    return d.map(function (e) {
                                        e = e.replace('(', '');
                                        e = e.replace(')', '');
                                        var coords = e.trim().split(' ');
                                        return [parseFloat(coords[0]), parseFloat(coords[1])];
                                    });
                                });
                                coordsArray = coordsArray.filter(function (v) { return !!v; });
                                var polygon = new Polygon({
                                    rings: coordsArray, spatialReference: { wkid: 102100 }
                                });
                                if (!polygon.isClockwise(polygon.rings)) {
                                    for (var i = 0; i < polygon.rings.length; i++) {
                                        polygon.rings[i] = polygon.rings[i].reverse();
                                    }
                                }
                                return polygon;
                            }
                        });
                        return [2 /*return*/, geometryJSON.filter(function (v) { return !!v; }).reduce(function (x, value) { return x.concat(value); }, [])];
                }
            });
        });
    };
    LayerService.prototype.turnOnLayerIds = function (layerIds) {
        var e_28, _a;
        try {
            for (var _b = tslib_1.__values(Object.values(this.mapLayers).flat()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var layer = _c.value;
                if (layer.mapcoreProps && layer.mapcoreProps.idFromSavedMap && layerIds.indexOf(layer.mapcoreProps.idFromSavedMap) >= 0) {
                    layer.mapcoreProps.visible = true;
                    layer.visible = true;
                    this.tooltipService.setPopupTemplateVisibility(layer);
                    layer.refresh();
                }
            }
        }
        catch (e_28_1) { e_28 = { error: e_28_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_28) throw e_28.error; }
        }
        this.mapLayersSub.next(this.mapLayers);
    };
    LayerService.prototype.removeAoiLayers = function () {
        var aoiLayers = this.getAoiLayers();
        if (this.mapRef) {
            this.mapRef.removeMany(aoiLayers);
        }
    };
    LayerService.prototype.getAoiLayers = function () {
        return Object.values(this.mapLayers).flat().filter(function (l) {
            return l.mapcoreProps.isAOI;
        });
    };
    LayerService.prototype.getMapLayers = function () {
        return Object.values(this.mapLayers).flat();
    };
    /**
     * Return a list of temporary layers use internally by MapCore.
     */
    LayerService.prototype.getTempLayers = function () {
        var _this = this;
        return Object.values(this.mapLayers).flat().filter(function (x) { return _this.isTempLayer(x); });
    };
    /**
     * Return true if a layer is for internal MapCore temporary use only.
     */
    LayerService.prototype.isTempLayer = function (layer) {
        return (layer.mapcoreProps && layer.mapcoreProps.hideInLegend);
    };
    LayerService.prototype.getLayerFeatures = function (layer, outFields) {
        if (outFields === void 0) { outFields = ['*']; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_29, _a, retval, cloneSublayer, query, result, wmu, _b, _c, feature, geometry, segLength;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        retval = null;
                        if (!(layer && layer.mapcoreProps && layer.mapcoreProps.geometryTypes && layer.mapcoreProps.geometryTypes.includes('line'))) return [3 /*break*/, 3];
                        cloneSublayer = layer.mapcoreProps.geometryTypes.length > 1 ? layer.sublayers.toArray()[1].clone() : layer.sublayers.toArray()[0].clone();
                        query = cloneSublayer.createQuery();
                        query.outFields = outFields;
                        query.returnGeometry = true;
                        return [4 /*yield*/, cloneSublayer.queryFeatures(query)];
                    case 1:
                        result = _d.sent();
                        if (!(result && result.features)) return [3 /*break*/, 3];
                        return [4 /*yield*/, ESRI.WebMercatorUtils];
                    case 2:
                        wmu = _d.sent();
                        try {
                            for (_b = tslib_1.__values(result.features), _c = _b.next(); !_c.done; _c = _b.next()) {
                                feature = _c.value;
                                geometry = feature.geometry;
                                geometry.startLatLong = wmu.xyToLngLat(geometry.paths[0][0][0], geometry.paths[0][0][1]).reverse();
                                segLength = geometry.paths[0].length - 1;
                                geometry.endLatLong = wmu.xyToLngLat(geometry.paths[0][segLength][0], geometry.paths[0][segLength][1]).reverse();
                            }
                        }
                        catch (e_29_1) { e_29 = { error: e_29_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_29) throw e_29.error; }
                        }
                        retval = result.features;
                        _d.label = 3;
                    case 3: return [2 /*return*/, retval];
                }
            });
        });
    };
    LayerService.prototype.getLayerType = function (layer) {
        if (layer.type === 'group') {
            return 'group';
        }
        else if (layer && layer.sublayers !== undefined && layer.sublayers.length > 0) {
            return 'dynamic';
        }
        else if (layer.type === 'feature' || layer === 'feature') {
            return 'feature';
        }
        else if (layer.graphics !== null) {
            return 'graphics';
        }
    };
    LayerService.prototype.getObjectIdColumnName = function (mapcoreProps) {
        var columnIdentifierIdForObjectId = 10;
        if (mapcoreProps && mapcoreProps.columns) {
            var filterResults = mapcoreProps.columns.filter(function (x) { return x.columnIdentifierId === columnIdentifierIdForObjectId; });
            if (filterResults.length > 0) {
                return filterResults[0].name.toLowerCase();
            }
        }
        return 'objectid';
    };
    LayerService.prototype.deletelayer = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.delete(layerId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.refreshLayers = function () {
        this.mapLayers.dynamic.forEach(function (layer) { return layer.refresh(); });
        this.mapLayers.feature.forEach(function (layer) { return layer.refresh(); });
        this.mapLayers.mapImage.forEach(function (layer) { return layer.refresh(); });
        this.layersRefreshed.emit();
    };
    /**
     * Get the layers geometry or request it from the server if not available client-side.
     */
    LayerService.prototype.getLayerGeometry = function (layer, first) {
        if (first === void 0) { first = 1000; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var geometry, _a, layerData, query, queryTask, response;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = layer.type;
                        switch (_a) {
                            case 'map-image': return [3 /*break*/, 1];
                            case 'feature': return [3 /*break*/, 4];
                            case 'graphics': return [3 /*break*/, 9];
                        }
                        return [3 /*break*/, 10];
                    case 1: return [4 /*yield*/, this.layerApi.getData(layer.mapcoreProps.parentId, ['GEOMETRY'], layer.mapcoreProps.query, first)];
                    case 2:
                        layerData = _b.sent();
                        return [4 /*yield*/, this.convertGeometry(layerData)];
                    case 3:
                        geometry = _b.sent();
                        return [3 /*break*/, 11];
                    case 4:
                        if (!layer.url) return [3 /*break*/, 7];
                        query = layer.createQuery();
                        query.returnGeometry = true;
                        query.where = '1=1';
                        return [4 /*yield*/, ESRI.QueryTask];
                    case 5:
                        QueryTask = _b.sent();
                        queryTask = new QueryTask({
                            url: layer.url + "/" + layer.layerId
                        });
                        return [4 /*yield*/, queryTask.execute(query)];
                    case 6:
                        response = _b.sent();
                        geometry = response.features.map(function (f) { return f.geometry; });
                        return [3 /*break*/, 8];
                    case 7:
                        geometry = layer.source.toArray().map(function (s) { return s.geometry; });
                        _b.label = 8;
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        geometry = layer.graphics.toArray().map(function (i) { return i.geometry; });
                        return [3 /*break*/, 11];
                    case 10:
                        geometry = null;
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/, geometry];
                }
            });
        });
    };
    /**
     * Get the layers geometry filtering out geometries that do not match the primary geometry.
     * Use this function for processing that expects a layer to have only one type of geometry.
     * Our export shapefile using export.py expects only one type of geometry.
     * @param layer Layer to return geometry for
     * @param first Limit number of geometries returned.
     * @returns Array of geometries with non-matching geometries discarded.
     */
    LayerService.prototype.getLayerGeometrySingleType = function (layer, first) {
        if (first === void 0) { first = 1000; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var geometry;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLayerGeometry(layer, first)];
                    case 1:
                        geometry = _a.sent();
                        if (Array.isArray(geometry)) {
                            return [2 /*return*/, geometry.filter(function (g) { return g.type === geometry[0].type; })];
                        }
                        return [2 /*return*/, geometry];
                }
            });
        });
    };
    LayerService.prototype.getLayerGraphicsWithFormattedSymbol = function (layer, symbol) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_30, _a, graphics, geometries, graphicDefinitions, graphics_1, graphics_1_1, graphic, graphicDefinition;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.Graphic];
                    case 1:
                        Graphic = _b.sent();
                        return [4 /*yield*/, this.getLayerGeometry(layer)];
                    case 2:
                        geometries = _b.sent();
                        if (geometries && Array.isArray(geometries)) {
                            graphics = geometries.map(function (g) {
                                return new Graphic({
                                    geometry: g,
                                    symbol: symbol
                                });
                            });
                        }
                        graphicDefinitions = [];
                        if (graphics) {
                            try {
                                for (graphics_1 = tslib_1.__values(graphics), graphics_1_1 = graphics_1.next(); !graphics_1_1.done; graphics_1_1 = graphics_1.next()) {
                                    graphic = graphics_1_1.value;
                                    graphicDefinition = graphic.toJSON();
                                    graphicDefinition.geometry.type = graphic.geometry.type;
                                    this.legendService.convertSymbolJSONToSymbolDefinition(graphicDefinition.symbol);
                                    graphicDefinitions.push(graphicDefinition);
                                }
                            }
                            catch (e_30_1) { e_30 = { error: e_30_1 }; }
                            finally {
                                try {
                                    if (graphics_1_1 && !graphics_1_1.done && (_a = graphics_1.return)) _a.call(graphics_1);
                                }
                                finally { if (e_30) throw e_30.error; }
                            }
                        }
                        return [2 /*return*/, graphicDefinitions];
                }
            });
        });
    };
    LayerService.prototype.getUserLayersFolders = function (userId, applicationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = "id, folders(category:\"layers\", applicationId:" + applicationId + ") {id, applicationId, name, parentUserFolderId, layers{id} }";
                        return [4 /*yield*/, this.layerApi.getUserLayersFolders(userId, props)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.getDrawLayersFolders = function (userId, applicationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = "id, folders(category:\"drawing-layers\", applicationId:" + applicationId + ") {id, applicationId, name, parentUserFolderId, layers{id} }";
                        return [4 /*yield*/, this.layerApi.getUserLayersFolders(userId, props)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.saveLayerToUserFolder = function (layerId, folderId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.saveLayerToUserFolder(layerId, folderId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.emailAboutSharedLayer = function (layerId, layerName, emailAddresses, emailSubject, emailBody) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        emailBody = this._buildMessage(emailBody, layerId, layerName);
                        return [4 /*yield*/, this.layerApi.emailAboutSharedLayer(emailAddresses, emailSubject, emailBody)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype._buildMessage = function (message, layerId, layerName) {
        var appName = environment.appName ? environment.appName : '';
        var layerUrl = this.getLayerUrl(layerId);
        var template = "I've shared a new layer with you from " + appName + " named " + layerName + ". You can view the layer in " + appName + " by going to the Layers dialog.\n\n " + layerUrl;
        if (message) {
            template += "\n\nMessage from user: " + message;
        }
        return template;
    };
    LayerService.prototype.getLayerUrl = function (layerId) {
        var baseUrl = environment.deepLinkBaseUrl || window.location.href.split('?')[0];
        return baseUrl + "?layer-id=" + layerId;
    };
    LayerService.prototype.applyCyfyLayerFilterTransform = function (paramConfig, mapcoreProps) {
        var e_31, _a;
        try {
            for (var _b = tslib_1.__values(paramConfig.filter(function (config) { return config.type === 'CYFY'; })), _c = _b.next(); !_c.done; _c = _b.next()) {
                var cyfyConfig = _c.value;
                if (cyfyConfig.layers.indexOf(mapcoreProps.parentId) > -1) {
                    cyfyConfig.value = 'fy';
                    this.updateLayerName(cyfyConfig, mapcoreProps);
                }
            }
        }
        catch (e_31_1) { e_31 = { error: e_31_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_31) throw e_31.error; }
        }
    };
    LayerService.prototype.updateLayerName = function (cyfyConfig, mapcoreProps) {
        var isRenameLayerRegex = /(XXXX|(C|F)Y\d\d\d\d)/;
        var yearOffset;
        if (mapcoreProps.query.subqueries) {
            if (mapcoreProps.query.subqueries.find(function (x) { return x.field === 'fy_plan_year_no'; })) {
                yearOffset = mapcoreProps.query.subqueries.find(function (x) { return x.field === 'fy_plan_year_no'; });
            }
            else if (mapcoreProps.query.subqueries.find(function (x) { return x.field === 'cy_plan_year_no'; })) {
                yearOffset = mapcoreProps.query.subqueries.find(function (x) { return x.field === 'cy_plan_year_no'; });
            }
        }
        else if (mapcoreProps.query.field && (mapcoreProps.query.field === 'fy_plan_year_no' || mapcoreProps.query.field === 'cy_plan_year_no')) {
            yearOffset = mapcoreProps.query;
        }
        if (yearOffset && cyfyConfig.value === 'fy') {
            yearOffset.field = 'fy_plan_year_no';
        }
        else if (yearOffset && cyfyConfig.value === 'cy') {
            yearOffset.field = 'cy_plan_year_no';
        }
        if (mapcoreProps.parentQuery && mapcoreProps.parentQuery.field && yearOffset && (cyfyConfig.value === 'fy' || cyfyConfig.value === 'cy')) {
            mapcoreProps.parentQuery.field = yearOffset.field;
        }
        if (isRenameLayerRegex.test(mapcoreProps.name) && yearOffset) {
            var yearToDisplay = this.generateYearDisplay(cyfyConfig.value, yearOffset.value);
            mapcoreProps.name = mapcoreProps.name.replace(isRenameLayerRegex, yearToDisplay);
        }
    };
    LayerService.prototype.getFiscalYear = function () {
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();
        if (month >= 7) {
            return year;
        }
        else {
            return year - 1;
        }
    };
    LayerService.prototype.getCurrentYear = function () {
        return new Date().getFullYear();
    };
    LayerService.prototype.getRamdonIdForEsriLayer = function () {
        return uuid.v1(null, 0, 0).substring(0, 7) + "-layer";
    };
    LayerService.prototype.generateYearDisplay = function (yearType, offset) {
        var displayString = '', year;
        if (yearType === 'cy') {
            displayString += 'CY';
            year = new Date().getFullYear();
        }
        else {
            displayString += 'FY';
            year = this.getFiscalYear();
        }
        // year = current year + offset - 1
        // current year is offset = 1
        displayString += (year + parseInt(offset, 0) - 1).toString();
        return displayString;
    };
    LayerService.prototype.applyCurrentFYTransformation = function (mapcoreProps) {
        var currentYear = this.getCurrentYear();
        var lastYear = currentYear - 1;
        var isCurrentFYRenameLayerRegex = /FYZZZZ/;
        if (isCurrentFYRenameLayerRegex.test(mapcoreProps.name)) {
            mapcoreProps.name = mapcoreProps.name.replace(isCurrentFYRenameLayerRegex, "FY" + this.getFiscalYear());
        }
        //this is for Visualization of Period Plan - Calendar Year map. CYZZZZ is intentionally converted to FY{currentYear}
        var isCurrentCYRenameLayerRegex = /CYZZZZ/;
        if (isCurrentCYRenameLayerRegex.test(mapcoreProps.name)) {
            mapcoreProps.name = mapcoreProps.name.replace(isCurrentCYRenameLayerRegex, "FY" + currentYear);
        }
        //this is for Visualization of Period Plan - Calendar Year map. CYZZZY is intentionally converted to FY{lastYear}
        var isLastCYRenameLayerRegex3 = /CYZZZY/;
        if (isLastCYRenameLayerRegex3.test(mapcoreProps.name)) {
            mapcoreProps.name = mapcoreProps.name.replace(isLastCYRenameLayerRegex3, "FY" + lastYear);
        }
    };
    LayerService.prototype.getLayerForSaveMap = function (layer, isNew) {
        if (isNew === void 0) { isNew = false; }
        return this.getLayerForSave(layer, null, null, LayerTypeId.Map, isNew, true);
    };
    LayerService.prototype.getLayerForSave = function (layer, name, description, typeId, isNew, isMapLayer) {
        if (isNew === void 0) { isNew = false; }
        if (isMapLayer === void 0) { isMapLayer = false; }
        if (layer.type === 'group') {
            return {
                isGroupLayer: true,
                isGroupParent: true,
                groupParentUniqueId: layer.id,
                splitThemeLabel: layer.mapcoreProps.splitThemeLabel,
                splitThemeJSON: layer.mapcoreProps.splitTheme ? JSON.stringify(this.splitThemeService.getThemeForSave(layer.mapcoreProps.splitTheme)) : undefined
            };
        }
        var mapcoreProps = tslib_1.__assign({}, layer.mapcoreProps);
        mapcoreProps.originalMinScale = layer.minScale;
        mapcoreProps.originalMaxScale = layer.maxScale;
        var id = null;
        if (!isNew) {
            // If saving layer and there's an existing ID
            if (!isMapLayer && mapcoreProps.idFromSavedLayer) {
                id = mapcoreProps.idFromSavedLayer;
            }
            else {
                id = mapcoreProps.id;
            }
        }
        var mapcoreLayer = {
            id: id,
            name: name || mapcoreProps.name,
            parentId: mapcoreProps.parentId,
            typeId: typeId || mapcoreProps.typeId,
            description: description,
            queryJSON: this.modifyQueryForSave(mapcoreProps),
            url: mapcoreProps.url,
            originalMinScale: mapcoreProps.originalMinScale,
            originalMaxScale: mapcoreProps.originalMaxScale,
            isAOI: mapcoreProps.isAOI,
            splitThemeLabel: mapcoreProps.splitThemeLabel
        };
        if (isMapLayer) {
            mapcoreLayer.visible = layer.visible ? null : layer.visible;
            mapcoreLayer.opacity = layer.opacity === 1 ? null : layer.opacity;
            if (layer.mapcoreProps.groupParent) {
                mapcoreLayer.groupParentName = layer.mapcoreProps.groupParent.name;
                mapcoreLayer.groupParentUniqueId = layer.mapcoreProps.groupParent.groupId;
                mapcoreLayer.isGroupLayer = true;
                mapcoreLayer.isGroupLayerExpanded = layer.mapcoreProps.groupParent.isOpen;
            }
        }
        if (!mapcoreLayer.id) {
            delete mapcoreLayer.id;
        }
        this.modifyRenderersForSave(layer, mapcoreLayer);
        if (mapcoreProps.labelingInfo && mapcoreProps.labelingInfo.length) {
            mapcoreLayer.labelingInfoJSON = JSON.stringify(mapcoreProps.labelingInfo);
        }
        if (mapcoreProps.routingDetail) {
            mapcoreLayer.routingDetailJSON = JSON.stringify(mapcoreProps.routingDetail);
        }
        return mapcoreLayer;
    };
    LayerService.prototype.modifyQueryForSave = function (mapcoreProps) {
        var queryJSON = null;
        var query;
        if (mapcoreProps.query) {
            query = tslib_1.__assign({}, mapcoreProps.query);
            if (mapcoreProps.spatialQueryParams) {
                query.spatialQueryParams = mapcoreProps.spatialQueryParams;
            }
            if (mapcoreProps.parentQuery) {
                query.parentQuery = mapcoreProps.parentQuery;
            }
            queryJSON = JSON.stringify(query);
        }
        else {
            var saveParams = null;
            if (mapcoreProps.spatialQueryParams) {
                saveParams.spatialQueryParams = mapcoreProps.spatialQueryParams;
            }
            if (mapcoreProps.parentQuery) {
                saveParams.parentQuery = mapcoreProps.parentQuery;
            }
            queryJSON = JSON.stringify(saveParams);
        }
        return queryJSON;
    };
    LayerService.prototype.modifyRenderersForSave = function (layer, mapcoreLayer) {
        var renderers = [{ type: 'opacity', value: layer.opacity }];
        if (layer.type === 'feature') {
            if (mapcoreLayer.url) {
                mapcoreLayer.url = layer.url + "/" + layer.layerId;
            }
            else {
                mapcoreLayer.graphicsJSON = this.getStringifiedFeaturesForLayer(layer);
            }
            renderers.push(layer.renderer.toJSON());
        }
        if (layer.type === 'graphics') {
            mapcoreLayer.graphicsJSON = this.getStringifiedGraphicsForLayer(layer);
        }
        if (layer.type === 'map-image') {
            renderers.push.apply(renderers, tslib_1.__spread(layer.sublayers.toArray().map(function (sublayer) { return sublayer.renderer.toJSON(); })));
        }
        mapcoreLayer.renderersJSON = JSON.stringify(renderers);
    };
    LayerService.prototype.getBaseParentId = function (parentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getBaseParentId(parentId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerService.prototype.fixPictureSymbols = function (symbols) {
        var e_32, _a;
        try {
            for (var symbols_2 = tslib_1.__values(symbols), symbols_2_1 = symbols_2.next(); !symbols_2_1.done; symbols_2_1 = symbols_2.next()) {
                var symbol = symbols_2_1.value;
                if (isPictureMarkerSymbol(symbol) && typeof (symbol.url) === 'object') {
                    //Esri contructor for loaded in PictureMarkerSymbol JSON puts the values into an object in url attr, this code below is a hack to assign those properties back to their correct locations
                    var symbolObject = symbol.url;
                    symbol.angle = symbolObject.angle;
                    symbol.height = symbolObject.height;
                    symbol.width = symbolObject.width;
                    symbol.xoffset = symbolObject.xoffset;
                    symbol.yoffset = symbolObject.yoffset;
                    symbol.url = symbolObject.url || symbolObject.imageData;
                    if (!symbol.url.startsWith('data:image/png;base64,') && !symbol.url.startsWith('http')) {
                        symbol.url = "data:image/png;base64," + symbol.url;
                    }
                }
            }
        }
        catch (e_32_1) { e_32 = { error: e_32_1 }; }
        finally {
            try {
                if (symbols_2_1 && !symbols_2_1.done && (_a = symbols_2.return)) _a.call(symbols_2);
            }
            finally { if (e_32) throw e_32.error; }
        }
    };
    LayerService.prototype.identifyMapImagelayers = function (mapPoint, checkLayerVisibility, includeChildTableDictionary, queryTolerance, additionalQueryDistance) {
        if (queryTolerance === void 0) { queryTolerance = null; }
        if (additionalQueryDistance === void 0) { additionalQueryDistance = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapImageLayers, sublayerArrays, sublayers, results, fields, baseParentIdDict, parentIdToChildTableDict, parentIds, setChildTablesToDictionary_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mapImageLayers = this.mapView.map.allLayers.toArray().filter(function (layer) {
                            return layer.type === 'map-image'
                                && (checkLayerVisibility
                                    ? (layer.visible && _this.layerIdentifyEnabled(layer)) || _this.layerIdentifyNonVisibleEnabled(layer)
                                    : true)
                                && (!layer.maxScale || _this.mapView.scale > layer.maxScale)
                                && (!layer.minScale || _this.mapView.scale < layer.minScale);
                        });
                        sublayerArrays = mapImageLayers.map(function (x) { return x.sublayers.toArray(); });
                        sublayers = tslib_1.__spread(sublayerArrays.flat());
                        results = [];
                        fields = {};
                        baseParentIdDict = new Map();
                        parentIdToChildTableDict = new Map();
                        if (!includeChildTableDictionary) return [3 /*break*/, 2];
                        parentIds = sublayers.map(function (sublayer) {
                            var retVal = null;
                            var mapcoreProps = _this.getSourceMapcoreProps(sublayer);
                            if (mapcoreProps && mapcoreProps.parentId) {
                                retVal = mapcoreProps.parentId;
                            }
                            return retVal;
                        }).filter(function (x) { return x; });
                        if (!parentIds.length) return [3 /*break*/, 2];
                        setChildTablesToDictionary_1 = function (parentId, key) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var layerChildTables;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.getLayerChildTables(parentId)];
                                    case 1:
                                        layerChildTables = _a.sent();
                                        if (layerChildTables && layerChildTables.length) {
                                            parentIdToChildTableDict.set(key || parentId, layerChildTables);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        return [4 /*yield*/, Promise.all(parentIds.map(function (parentId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var baseParentId;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(!parentIdToChildTableDict.has(parentId) && !baseParentIdDict.has(parentId))) return [3 /*break*/, 2];
                                            return [4 /*yield*/, setChildTablesToDictionary_1(parentId)];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            if (!(!parentIdToChildTableDict.has(parentId) && baseParentIdDict.has(parentId) && baseParentIdDict.get(parentId))) return [3 /*break*/, 4];
                                            return [4 /*yield*/, setChildTablesToDictionary_1(baseParentIdDict.get(parentId), parentId)];
                                        case 3:
                                            _a.sent();
                                            return [3 /*break*/, 7];
                                        case 4:
                                            if (!!baseParentIdDict.has(parentId)) return [3 /*break*/, 7];
                                            return [4 /*yield*/, this.getBaseParentId(parentId)];
                                        case 5:
                                            baseParentId = _a.sent();
                                            baseParentIdDict.set(parentId, baseParentId);
                                            if (!baseParentId) return [3 /*break*/, 7];
                                            return [4 /*yield*/, setChildTablesToDictionary_1(baseParentIdDict.get(parentId), parentId)];
                                        case 6:
                                            _a.sent();
                                            _a.label = 7;
                                        case 7: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, Promise.all(sublayers.map(function (sublayer) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var mapcoreProps, query, queryResult, existingField_1;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        mapcoreProps = this.getSourceMapcoreProps(sublayer);
                                        if (!mapcoreProps) return [3 /*break*/, 2];
                                        query = sublayer.createQuery();
                                        query.geometry = mapPoint;
                                        query.outFields = mapcoreProps.columns ? mapcoreProps.columns.map(function (x) { return x.name; }) : ['*'];
                                        query.spatialRelationship = 'intersects';
                                        query.returnGeometry = true;
                                        this.setTolerance(query, queryTolerance, additionalQueryDistance);
                                        return [4 /*yield*/, sublayer.queryFeatures(query)];
                                    case 1:
                                        queryResult = _a.sent();
                                        if (queryResult.features) {
                                            existingField_1 = fields[sublayer.parent.id];
                                            if (existingField_1) {
                                                existingField_1.push.apply(existingField_1, tslib_1.__spread(queryResult.fields.filter(function (f) { return !existingField_1.find(function (ef) { return ef.name === f.name; }); })));
                                            }
                                            else {
                                                fields[sublayer.parent.id] = queryResult.fields;
                                            }
                                            results = results.concat(queryResult.features.reverse().map(function (feature) { return ({
                                                attributes: tslib_1.__assign({}, feature.attributes),
                                                geometry: feature.geometry.clone(),
                                                layer: sublayer.parent,
                                                sourceLayer: feature.sourceLayer,
                                                layerName: mapcoreProps.name,
                                                childTables: _this.getChildTableResult(includeChildTableDictionary, mapcoreProps, parentIdToChildTableDict)
                                            }); }));
                                        }
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); }))];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, { features: results, fields: fields }];
                }
            });
        });
    };
    LayerService.prototype.getSourceMapcoreProps = function (sourceLayer) {
        var retVal = null;
        if (sourceLayer) {
            if (sourceLayer.mapcoreProps && (sourceLayer.mapcoreProps.columns || sourceLayer.type === 'feature' || sourceLayer.type === 'graphics')) {
                retVal = sourceLayer.mapcoreProps;
            }
            else if (sourceLayer.parent && sourceLayer.parent.mapcoreProps) {
                retVal = sourceLayer.parent.mapcoreProps;
            }
        }
        return retVal;
    };
    LayerService.prototype.layerIdentifyNonVisibleEnabled = function (layer) {
        var mapcoreProps = this.getSourceMapcoreProps(layer);
        /* tslint:disable-next-line:no-boolean-literal-compare */
        return mapcoreProps.identifyNonVisibleEnabled === true;
    };
    LayerService.prototype.layerIdentifyEnabled = function (layer) {
        var mapcoreProps = this.getSourceMapcoreProps(layer);
        /* tslint:disable-next-line:no-boolean-literal-compare */
        return mapcoreProps ? mapcoreProps.identifyEnabled !== false : false;
    };
    LayerService.prototype.getTolerance = function (tolerance) {
        var inchesInFoot = 12;
        var ppi = 72;
        return Math.round(this.mapView.scale / ppi / inchesInFoot * tolerance);
    };
    LayerService.prototype.setTolerance = function (query, tolerance, additionalDistance) {
        if (tolerance === void 0) { tolerance = null; }
        if (additionalDistance === void 0) { additionalDistance = null; }
        if (tolerance === null) {
            tolerance = 5;
        }
        if (additionalDistance === null) {
            additionalDistance = 0;
        }
        query.distance = Math.max(0, this.getTolerance(tolerance) + additionalDistance);
        query.units = 'feet';
    };
    LayerService.prototype.saveClassBreakLabels = function (layer) {
        layer.mapcoreProps.classBreakLabels = this.themeService.generateClassBreakLabels(layer);
    };
    LayerService.prototype.getChildTableResult = function (includeChildTableDictionary, mapcoreProps, parentIdToChildTableDict) {
        var result;
        if (includeChildTableDictionary) {
            var childTables = parentIdToChildTableDict.get(mapcoreProps.parentId);
            if (childTables) {
                result = childTables.map(function (x) { return (tslib_1.__assign({}, x)); });
            }
        }
        return result;
    };
    LayerService.ngInjectableDef = i0.defineInjectable({ factory: function LayerService_Factory() { return new LayerService(i0.inject(i1.LayerApi), i0.inject(i2.LegendService), i0.inject(i3.SplitThemeService), i0.inject(i4.TooltipService), i0.inject(i5.ThemeService), i0.inject(i6.ToSqlStringService), i0.inject(i7.HttpClient), i0.inject("LoggingService")); }, token: LayerService, providedIn: "root" });
    return LayerService;
}());
export { LayerService };
